import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ViewEncapsulation,
  OnDestroy,
  ChangeDetectorRef,
} from "@angular/core";
import { MatSelect } from "@angular/material/select";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { opdEnvironment } from "../../properties/opd-field-properties";
import { AppointmentService } from "../../services/Sappointment.service";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
} from "@angular/forms";
import { DatePipe } from "@angular/common";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { ReplaySubject, Subject, Subscription, takeUntil } from "rxjs";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { Router, ActivatedRoute } from "@angular/router";
import { AppointmentDetailsComponent } from "./appointment-details/appointment-details.component";
import { ItemModel } from "@syncfusion/ej2-angular-splitbuttons";
import { TextBoxComponent } from "@syncfusion/ej2-angular-inputs";
import {
  ScheduleComponent,
  GroupModel,
  View,
  EventSettingsModel,
  Timezone,
  ResourcesModel,
  PopupOpenEventArgs,
  TimeScaleModel,
  DayService,
  WeekService,
  WorkWeekService,
  MonthService,
  YearService,
  AgendaService,
  TimelineViewsService,
  TimelineMonthService,
  TimelineYearService,
  PrintService,
  ExcelExportService,
  ICalendarExportService,
  DragAndDropService,
  NavigatingEventArgs,
} from "@syncfusion/ej2-angular-schedule";
import { extend, Internationalization, loadCldr, setCulture } from "@syncfusion/ej2-base";
import { SwitchComponent } from "@syncfusion/ej2-angular-buttons";
import {
  MultiSelectComponent,
  ChangeEventArgs,
  MultiSelectChangeEventArgs,
  DropDownListComponent,
} from "@syncfusion/ej2-angular-dropdowns";
import { Predicate, Query } from "@syncfusion/ej2-data";
import {
  ContextMenuComponent,
  MenuItemModel,
} from "@syncfusion/ej2-angular-navigations";
import { ChangeEventArgs as TimeEventArgs } from "@syncfusion/ej2-calendars";
import { MatTableDataSource } from "@angular/material/table";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { MasterUrlService } from "../../services/SmasterUrl.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { removeSpaces } from "../../helper/helper.service";
import {
  OPD_REPORT_NAME,
  OPD_REPORT_TYPE,
} from "../../properties/opd-report-properties";
import { opdNavigation } from "../../properties/opd-navigation-properties";
import { ConfirmRemarksComponent } from "./confirm-remarks/confirm-remarks.component";
import { AppointmentQuickSearchComponent } from "./appointment-quick-search/appointment-quick-search.component";
import {
  PATIENT_SEARCH,
} from "../../properties/patient-search-properties";
import { SearchModel } from "../../models/MsearchModel";
import moment from "moment";
import { dataObj } from "../../models/MpatientRegistration";
import { baseObj, baseObject } from "../../interface/IerRegistration";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MASTERSSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/master-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { PatientDTOObject } from "projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.component";
import { ApplicationConfigService } from "projects/lib/medcare-core-lib/src/lib/services/application-config.service";
import { AuthService } from "projects/lib/medcare-core-lib/src/lib/services/auth.service";
import { EnvoirnmentService } from "projects/lib/medcare-core-lib/src/lib/services/envoirnment.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { ReportService } from "projects/lib/medcare-core-lib/src/lib/services/report.service";
import { Langauge, MasterMenus } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { MasterKeys } from "projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants";
import { RecurringAppointmentsComponent } from "./recurring-appointments/recurring-appointments.component";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { STATICCODESERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/static-code-service";
import { SearchHeaderService } from "../../services/SsearchHeader.service";
import { SameDayAppointmentDialogComponent } from "../../shared/same-day-appointment-check-dailog/same-day-appointment-dialog/same-day-appointment-dialog.component";
const numberingSystems = require('cldr-data/supplemental/numberingSystems.json');
const gregorian = require('cldr-data/main/th/ca-gregorian.json');
const numbers = require('cldr-data/main/th/numbers.json');
const timeZoneNames = require('cldr-data/main/th/timeZoneNames.json');
const weekData = require('cldr-data/supplemental/weekData.json');
const buddhist = require('cldr-data/main/th/ca-buddhist.json');

export interface DialogData {
  name: string;
}
@Component({
  selector: "app-patient-appointment",
  templateUrl: "./patient-appointment.component.html",
  styleUrls: ["./patient-appointment.component.scss"],
  providers: [
    DatePipe,
    AuthService,
    DayService,
    WeekService,
    WorkWeekService,
    MonthService,
    YearService,
    AgendaService,
    TimelineViewsService,
    TimelineMonthService,
    TimelineYearService,
    PrintService,
    ExcelExportService,
    ICalendarExportService,
    DragAndDropService,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class PatientAppointmentComponent implements OnInit, OnDestroy {
  public deptCtrl: FormControl = new FormControl();
  public deptFilterCtrl: FormControl = new FormControl();
  public teleCtrl: FormControl = new FormControl();
  public teleFilterCtrl: FormControl = new FormControl();
  public appointmentTypeCtrl: FormControl = new FormControl();
  public appointmentTypeDFltrCtrl: FormControl = new FormControl();
  public doctorCtrl: FormControl = new FormControl();
  public doctorFltrCtrl: FormControl = new FormControl();
  public filteredDepts: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredTelecom: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredDocs: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredappointmentType: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  public environment: any = opdEnvironment;
  public currentDate: string;
  public name: string;
  public appointmentType: any = {};
  public appointmentTypeList: any = [];
  public Teleconsultations: any = [];
  public departmentList: any = [];
  public doctorList: any = [];
  multiLangDepartmentList: any[] = [];
  multiLangDoctorList: any[] = [];
  public departmentName: string;
  public department: any = {};
  public doctor: any = {};
  public teleconsultaion: any = {};
  public pageLoad = true;
  public deptFlag = false;
  mulipleDoctor: boolean = false;
  public activeDoctor: any = {
    code: "",
    id: "",
    name: "",
    department: "",
    email: "",
  };
  public values: any = {};
  public searchResult: any = {
    appointmentDate: {
      start: new Date(),
      end: new Date(),
    },
    doctor: "",
    mrnno: "",
  };
  public events = [];
  isHidden = false;
  minutesblock = 30;
  blockTime: any;
  unitId: any;
  unitCode: any;
  orgId: any;
  render: any;
  startDate: any;
  apptType: any;
  customArray: any[] = [];
  multiDocCheckbox: boolean = true;
  allSlots: any[] = [];
  multipleDoctors: any[] = [];
  parentMessage: any;
  details: any = {};
  multipleDoctorSlected: any[] = [];
  doctorsCount: string = "";
  private subscriptionList = new Subscription();
  searchJson = PATIENT_SEARCH;
  search: SearchModel = new SearchModel();
  patientSearchList: any;
  refreshTime: string = "";
  patient: PatientDTOObject = new PatientDTOObject();
  hidePatientSearch: boolean = false;
  offset = 0;
  limit = 20;
  totalElements = 0;
  isLoadingDoctors = false;

  //sync fusion calendar
  @ViewChild("scheduleObj", { static: true }) scheduleObj: ScheduleComponent;
  @ViewChild("singleSelect", { static: true }) singleSelect: MatSelect;
  @ViewChild("appointmentTypeSelect", { static: true })
  appointmentTypeSelect: MatSelect;
  @ViewChild("deptTypeSelect", { static: true }) deptTypeSelect: MatSelect;
  @ViewChild("doctorSelect", { static: true }) doctorSelect: MatSelect;

  @ViewChild("workWeekDaysObj", { static: true })
  workWeek: MultiSelectComponent;
  @ViewChild("resouresObj", { static: true }) resources: MultiSelectComponent;
  @ViewChild("eventTypeObj", { static: true })
  eventTypeObj: DropDownListComponent;
  @ViewChild("titleObj", { static: true }) titleObj: TextBoxComponent;
  @ViewChild("notesObj", { static: true }) notesObj: TextBoxComponent;
  @ViewChild("viewSwitch", { static: true }) viewSwitch: SwitchComponent;
  @ViewChild("groupSwitch", { static: true }) groupSwitch: SwitchComponent;
  @ViewChild("gridlinesSwitch", { static: true })
  gridlinesSwitch: SwitchComponent;
  @ViewChild("rowHeightSwitch", { static: true })
  rowHeightSwitch: SwitchComponent;
  @ViewChild("tooltipSwitch", { static: true }) tooltipSwitch: SwitchComponent;
  @ViewChild("dragSwitch", { static: true }) dragSwitch: SwitchComponent;
  @ViewChild("menuObj", { static: true }) public menuObj: ContextMenuComponent;
  public showFileList = false;
  public multiple = false;
  public intl: Internationalization = new Internationalization();
  public currentView: View = "Week"; //string not able to assigned
  public liveTimeUpdate: string = new Date().toLocaleTimeString(
    OPD_CONST.aptTimeRef.enus,
    {
      timeZone: OPD_CONST.aptTimeRef.utc,
    }
  );
  public group: GroupModel = { resources: [] };
  public resourceDataSource: Record<string, any>[] = OPD_CONST.aptResource;
  dataSource = new MatTableDataSource<any>();
  public resourceQuery: Query = null;
  public allowMultiple = false;
  public isTimelineView = false;
  public exportItems: ItemModel[] = OPD_CONST.aptItemModel;
  public checkboxMode = OPD_CONST.aptref.checkbox;
  public firstDayOfWeek = 0;
  public workDays: number[] = OPD_CONST.aptWorkDays;
  public calendarsValue: number[] = [1];
  public selectedResource: number = 1;
  public fields: Record<string, any> = OPD_CONST.aptRecords;
  public calendarFields: Record<string, any> = OPD_CONST.aptcalenderFields;
  public dayStartHourValue: Date = new Date(new Date().setHours(0, 0, 0));
  public dayEndHourValue: Date = new Date(new Date().setHours(23, 59, 59));
  public workStartHourValue: Date = new Date(new Date().setHours(9, 0, 0));
  public workEndHourValue: Date = new Date(new Date().setHours(18, 0, 0));
  public weekDays: Record<string, any>[] = OPD_CONST.aptweekDays;
  public timezoneData: Record<string, any>[] = OPD_CONST.aptTimeZone;
  public timeSlotDuration: Record<string, any>[] =
    OPD_CONST.aptTimeSlotDuration;
  public timeSlotFields = OPD_CONST.aptTimeSlotFields;
  public timeSlotCount: number[] = OPD_CONST.aptTimeSlotCount;
  public timeSlotDurationValue = 10;
  public timeSlotCountValue = 1;
  public timeFormatData: Record<string, any>[] = OPD_CONST.aptTimeFormatData;
  public timeFormatValue = OPD_CONST.aptref.time;
  public weekNumberData: Record<string, any>[] = OPD_CONST.aptWeekNumberValue;
  public weekNumberValue = OPD_CONST.aptref.off;
  public eventSettings: EventSettingsModel = {};
  public selectedTarget: Element;
  public menuItems: MenuItemModel[] = OPD_CONST.aptMenuModel;
  public timeScale: TimeScaleModel = OPD_CONST.aptTimeScaleModel;
  weatherData: any;
  toolData: any;
  isReschedule: boolean = false;
  IsRescheduleData: any;
  isHold: boolean = false;
  unHold: boolean = false;
  userRightList: any = [];
  isHoldSplRights: boolean = false;
  isUnHoldSplRights: boolean = false;
  isPermission: boolean = true;
  isDoctorVisible: boolean = true;
  isConsultationVisible:boolean=true;
  isQuickSearch: boolean = true;
  doctorFilteredList: any;
  docList: any;
  patientId: string = "";
  mrn: string = "";
  patientImage: string = "";
  patientInfoDisplay: string = "";
  isDisplayRemarks:boolean=false;
  imageUrl="";
  filteredDocsList:baseObject[] = []; 
  doctorSearch :string= '';
  startdate: number;
  endDate: number;
  isOverRightBlockedSlot: boolean=false;

  slotBlockDuration: number = OPD_CONST.defaultSlotsBlockDuration;
  isFromWaitingList:boolean=false;
  waitingPatient: any;
   viewOptions: any[] = [];
  orgCode: string;
  isSUHCOrg: boolean = false;
  isRecurringAppointments: boolean= false;
  private subjectClicked = false;
  langaugeValue: string;

  defaultApptType = '';
defaultConsultationType = '';
defaultDept = '';
  constructor(
    public dialog: MatDialog,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    private appoinmentService: AppointmentService,
    public loadingBar: LoadingBarService,
    public datepipe: DatePipe,
    public authService: AuthService,
    public router: Router,
    private route: ActivatedRoute,
    private langService: MultiLanguageService,
    public masterApiService: MasterUrlService,
    public generalApiService: GeneralUrlService,
    private applicationConfigService: ApplicationConfigService,
    private env: EnvoirnmentService
  ) {
    this.subscriptionList.add(
      route.data.subscribe((data) => {
        this.apptType = data[OPD_CONST.aptref.appt];
      })
    );
  }

  /**
   *Load method
   *
   * @memberof PatientAppointmentComponent
   */
  ngOnInit() {
    this.langaugeValue=localStorage.getItem("lan");
    if (this.langaugeValue === Langauge.TH) {
      setCulture('th');
      loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData ,buddhist);
    }
    this.onChanges();
    this.filteredDocsList = this.doctorList;

    this.imageUrl = this.env.apiUrl;
    this.authService.getUnit().then((value: any) => {
      this.unitId = value.unitId;
      this.unitCode = value.unitCode;
      this.orgId = value.orgId;
      this.orgCode = value.orgCode;
      this.isSUHCOrg = value.orgCode === "SUHC";
      this.getAppConfigList();
      this.getOrgAppConfigList();
    });
    this.authService.getGeneralSettingInfo().then((value: any) => {
      this.blockTime = value.slotTime;
    });
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightFreeze)
            this.isHoldSplRights = true;
          if (element.specialRightCode == OPD_CONST.splRightUnFreeze)
            this.isUnHoldSplRights = true;
          if (element.specialRightCode == OPD_CONST.splRightOverRighteBlockedSlot)
            this.isOverRightBlockedSlot = true;
        });
      }
    });

    this.subscriptionList.add(
      this.appointmentTypeDFltrCtrl.valueChanges.subscribe(() => {
        this.filterappointmentType();
      })
    );
    this.subscriptionList.add(
      this.teleFilterCtrl.valueChanges.subscribe(() => {
        this.filterteleconsulation();
      })
    );
    // this.getAppointmentTypeMaster();
    // this.getTeleApptype();
    this.getAppConfig();
    if (history.state && history.state.patient) {
      this.isFromWaitingList = true;
      this.waitingPatient = history.state.patient;
      this.appointmentType = this.waitingPatient.serviceCategory?.code || '';
      this.appointmentTypeChange(this.appointmentType);
      this.teleconsultaion = this.waitingPatient.consultationType?.code || '';
      this.consultationOnchange(this.teleconsultaion, true);
      this.department = this.waitingPatient.specialty?.[0]?.coding?.[0]?.code || '';
      let departmentvalue={value:this.department}
      this.departmentOnChange(departmentvalue,false, true);
    } else {
    this.isFromWaitingList=false;
    }
    this.setViewOptions();
  }
   getAppConfigList() {
       let mrdConfig: any;
       this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
       this.baseservice
         .getResource( "appConfiguration/findConfigByModule?unitCode="+this.unitCode+
           "&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
         .pipe(takeUntil(this._onDestroy))
         .subscribe((res) => {
         if (res) {
           mrdConfig = res.keys;
           mrdConfig.forEach((element) => {
             if (element.key == MasterKeys.Default_Appt_Type){
               if (element.valueList.length > 0) {
                 this.defaultApptType = element.valueList[0]?.code;
               }
             }
             if (element.key == MasterKeys.Default_Consultation_Type){
               if (element.valueList.length > 0) {
                 this.defaultConsultationType = element.valueList[0]?.code;
               }
             }
             if (element.key == MasterKeys.Default_Appt_Dept){
               if (element.valueList.length > 0) {
                 this.defaultDept = element.valueList[0]?.code;
               }
             }
           });
           this.getAppointmentTypeMaster();
           this.getTeleApptype();
           this.consultationOnchange(this.defaultConsultationType, true);
         }
       });
     }
   getOrgAppConfigList() {
      let appConfig: any;
       this.baseservice.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.baseservice
            .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
            .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res) {
            appConfig = res.keys;
            appConfig.forEach((element) => {
             
              if (element.key == MasterKeys.allowedRecurringAppointments){
                if (element.valueList?.length > 0 && element.valueList[0]?.code == "true") {
                  this.isRecurringAppointments = true;
              }
            }
          });
          } 
        });
    }  
  /**
   *
   *
   * @memberof PatientAppointmentComponent
   */
  public getAppConfig(): void {
    this.applicationConfigService
      .getModuleConfiguration(OPD_CONST.appConfigPatientManagement)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if(res) {
          let slotsKey = res.find(i => i.key == OPD_CONST.appConfigSlotsBlockDuration);
          this.slotBlockDuration = slotsKey.valueList && slotsKey.valueList.length > 0
            ? slotsKey.valueList[0].numberValue
            : OPD_CONST.defaultSlotsBlockDuration;
        }
      });
  }

  public updateLiveTime(timezone: string = OPD_CONST.aptTimeRef.utc): void {
    this.liveTimeUpdate = new Date().toLocaleTimeString(
      OPD_CONST.aptTimeRef.enus,
      {
        timeZone: timezone,
      }
    );
  }
  
  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    this.dataSource = new MatTableDataSource<any>();
    var dobFormatted = "";
    var patientAge = "";
    if (patient.dateOfBirth) {
      dobFormatted = this.datepipe.transform(patient.dateOfBirth, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.dateOfBirth ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";
    this.getAppointmentList();
  }

  /**
   *Change event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWeekDayChange(args: ChangeEventArgs): void {
    this.scheduleObj.firstDayOfWeek = args.value as number;
  }
  /**
   *workweek day change event
   *
   * @param {MultiSelectChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkWeekDayChange(args: MultiSelectChangeEventArgs): void {
    this.scheduleObj.workDays = args.value as number[];
  }

  /**
   *Resource change event
   *
   * @param {MultiSelectChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onResourceChange(args: MultiSelectChangeEventArgs): void {
    let resourcePredicate: Predicate;
    const values = args.value.map((item: any) => {
      // Transform `item` to the appropriate type
      return typeof item === 'object' && item.property ? item.property : item;
    });
    for (const value of values) {
      if (resourcePredicate) {
        resourcePredicate = resourcePredicate.or(
          new Predicate(
            OPD_CONST.aptTimeRef.calendarId,
            OPD_CONST.aptTimeRef.equal,
            value
          )
        );
      } else {
        resourcePredicate = new Predicate(
          OPD_CONST.aptTimeRef.calendarId,
          OPD_CONST.aptTimeRef.equal,
          value
        );
      }
    }
    this.scheduleObj.resources[0].query = resourcePredicate
      ? new Query().where(resourcePredicate)
      : new Query().where(
          OPD_CONST.aptTimeRef.calendarId,
          OPD_CONST.aptTimeRef.equal,
          1
        );
  }

  /**
   *On time zone change event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimezoneChange(args: ChangeEventArgs): void {
    this.scheduleObj.timezone = args.value as string;
    this.updateLiveTime(this.scheduleObj.timezone);
    document.querySelector(
      OPD_CONST.aptTimeRef.scheduleoverViewTime
    ).innerHTML = OPD_CONST.aptTimeRef.innerHtml + args.itemData.text;
  }

  /**
   *On Day StartHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onDayStartHourChange(args: TimeEventArgs): void {
    this.scheduleObj.startHour = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }

  /**
   *On Day EndHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onDayEndHourChange(args: TimeEventArgs): void {
    this.scheduleObj.endHour = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *On work StartHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkStartHourChange(args: TimeEventArgs): void {
    this.scheduleObj.workHours.start = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *On work EndHour Change event
   *
   * @param {TimeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWorkEndHourChange(args: TimeEventArgs): void {
    this.scheduleObj.workHours.end = this.intl.formatDate(args.value, {
      skeleton: OPD_CONST.aptTimeRef.hm,
    });
  }
  /**
   *onTimescaleDurationChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimescaleDurationChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeScale.interval = args.value as number;
  }
  /**
   *onTimescaleIntervalChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimescaleIntervalChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeScale.slotCount = args.value as number;
  }
  /**
   *onTimeFormatChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onTimeFormatChange(args: ChangeEventArgs): void {
    this.scheduleObj.timeFormat = args.value as string;
  }
  /**
   *onWeekNumberChange event
   *
   * @param {ChangeEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onWeekNumberChange(args: ChangeEventArgs): void {
    if (args.value === OPD_CONST.aptTimeRef.off) {
      this.scheduleObj.showWeekNumber = false;
    } else {
      this.scheduleObj.showWeekNumber = true;
      this.scheduleObj.weekRule = args.value as any;
    }
  }
  /**
   * getResourceData method
   *
   * @param {Record<string, any>} data
   * @return {*}  {Record<string, any>}
   * @memberof PatientAppointmentComponent
   */
  public getResourceData(data: Record<string, any>): Record<string, any> {
    const resources: ResourcesModel =
      this.scheduleObj.getResourceCollections()[0];
    const resourceData: Record<string, any> = (
      resources.dataSource as Record<string, any>[]
    ).filter(
      (resource: Record<string, any>) => resource["CalendarId"] === data["CalendarId"]
    )[0] as Record<string, any>;
    return resourceData;
  }
  /**
   *get header styles method
   *
   * @param {Record<string, any>} data
   * @return {*}  {Record<string, any>}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderStyles(data: Record<string, any>): Record<string, any> {
    if (data["elementType"] === OPD_CONST.aptHeaderStyle.cell) {
      return {
        "align-items": OPD_CONST.aptHeaderStyle.center,
        color: OPD_CONST.aptHeaderStyle.colorCode,
      };
    } else {
      const resourceData: Record<string, any> = this.getResourceData(data);
      let calendarColor = OPD_CONST.aptHeaderStyle.calenderColorCode;
      if (resourceData) {
        calendarColor = resourceData["CalendarColor"].toString();
      }
      return {
        background: calendarColor,
        color: OPD_CONST.aptHeaderStyle.calenderbgColor,
      };
    }
  }
  /**
   *get header method
   *
   * @param {Record<string, any>} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderTitle(data: Record<string, any>): string {
    return data["elementType"] === OPD_CONST.aptHeaderStyle.cell
      ? OPD_CONST.aptHeaderStyle.addAppointment
      : OPD_CONST.aptHeaderStyle.appointmentDetails;
  }
  /**
   *getHeaderDetails method
   *
   * @param {{ [key: string]: Date }} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getHeaderDetails(data: { [key: string]: Date }): string {
    return (
      this.intl.formatDate(data["StartTime"], {
        type: OPD_CONST.aptHeaderStyle.date,
        skeleton: OPD_CONST.aptHeaderStyle.full,
      }) +
      " (" +
      new Date(data["StartTime"]).toLocaleTimeString() +
      " - " +
      new Date(data["EndTime"]).toLocaleTimeString() +
      ")"
    );
  }
  /**
   *getEventType method
   *
   * @param {{ [key: string]: string }} data
   * @return {*}  {string}
   * @memberof PatientAppointmentComponent
   */
  public getEventType(data: { [key: string]: string }): string {
    const resourceData: Record<string, any> = this.getResourceData(data);
    let calendarText = "";
    if (resourceData) {
      calendarText = resourceData["CalendarText"].toString();
    }
    return calendarText;
  }
  /**
   *on print method
   *
   * @memberof PatientAppointmentComponent
   */
  public onPrintClick(): void {
    this.scheduleObj.print();
  }
  /**
   *export click method
   *
   * @param {*} args
   * @memberof PatientAppointmentComponent
   */
  public onExportClick(args): void {
    if (args.item.text === OPD_CONST.aptref.Excel) {
      let exportDatas: Record<string, any>[] = [];
      const eventCollection: Record<string, any>[] =
        this.scheduleObj.getEvents();
      const resourceCollection: ResourcesModel[] =
        this.scheduleObj.getResourceCollections();
      const resourceData: Record<string, any>[] = resourceCollection[0]
        .dataSource as Record<string, any>[];
      for (const resource of resourceData) {
        const data: Record<string, any>[] = eventCollection.filter(
          (e: Record<string, any>) => e["CalendarId"] === resource["CalendarId"]
        );
        exportDatas = exportDatas.concat(data as Record<string, any>[]);
      }
      this.scheduleObj.exportToExcel({
        exportType: "xlsx",
        customData: exportDatas,
        fields: OPD_CONST.aptExcelDisplay,
      });
    } else {
      this.scheduleObj.exportToICalendar();
    }
  }

  /**
   *popup open issue
   *
   * @param {PopupOpenEventArgs} args
   * @memberof PatientAppointmentComponent
   */
  public onPopupOpen(args: PopupOpenEventArgs): void {
     if(this.langaugeValue== Langauge.TH) {
      setTimeout(() => this.convertThaiYear(), 0);}
    if (args.type === OPD_CONST.aptref.quickInfo) {
     if (!this.subjectClicked) {
      this.eventClick(args.data); 
    }
    this.subjectClicked = false; 
    } else if (args.type == OPD_CONST.aptref.editor) {
      args.cancel = true;
    }
  }

  //---------------------------------- sync fusion calendar end -------
  /**
 search method
 *
 * @memberof PatientAppointmentComponent
 */
  initAutoComplete() {
    this.filteredDepts.next(this.departmentList.slice());
    this.subscriptionList.add(
      this.deptFilterCtrl.valueChanges.subscribe(() => {
        this.filterDepts();
      })
    );
    if (this.doctorList.length > 0) {
      this.doctorList.next(this.docList.slice());
      this.subscriptionList.add(
        this.appointmentTypeDFltrCtrl.valueChanges.subscribe(() => {
          this.filterDoc();
        })
      );

      this.subscriptionList.add(
        this.doctorFltrCtrl.valueChanges.subscribe(() => {
          this.filterDocs();
        })
      );
    }
  }

  /**
   *Destroy method
   *
   * @memberof PatientAppointmentComponent
   */
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
    if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
      localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
    if (localStorage.getItem(OPD_CONST.aptref.rescheduleApp)) {
      localStorage.removeItem(OPD_CONST.aptref.rescheduleApp);
    }
    if (localStorage.getItem(OPD_CONST.appoinmentRef.appointmentEncounter)) {
      localStorage.removeItem(OPD_CONST.appoinmentRef.appointmentEncounter);
    }
  }
  /**
   *filter departments method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDepts() {
    if (!this.departmentList) {
      return;
    }
    let search = this.deptFilterCtrl.value;
    if (!search) {
      this.filteredDepts.next(this.departmentList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepts.next(
      this.departmentList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter doctors method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDoc() {
    if (!this.docList) {
      return;
    }
    let search = this.appointmentTypeDFltrCtrl.value;
    if (!search) {
      this.doctorList.next(this.docList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.doctorList.next(
      this.docList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter teleconsulation list
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterteleconsulation() {
    if (!this.Teleconsultations) {
      return;
    }
    let search = this.teleFilterCtrl.value;
    if (!search) {
      this.filteredTelecom.next(this.Teleconsultations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTelecom.next(
      this.Teleconsultations.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter appointmetn Type method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterappointmentType() {
    if (!this.appointmentTypeList) {
      return;
    }
    let search = this.appointmentTypeDFltrCtrl.value;
    if (!search) {
      this.filteredappointmentType.next(this.appointmentTypeList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredappointmentType.next(
      this.appointmentTypeList.filter(
        (e) => e.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *get filter docs
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDocs() {
    if (!this.doctorList) {
      return;
    }
    let search = this.doctorFltrCtrl.value;
    if (!search) {
      this.filteredDocs.next(this.doctorList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDocs.next(
      this.doctorList.filter(
        (dept) => dept.name.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *after view intit
   *
   * @memberof PatientAppointmentComponent
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.currentDate = this.setDateHeader();
      if (this.langaugeValue === Langauge.TH) {
        this.convertThaiYear();
      }
    }, 500);
    document.addEventListener('click', (e: any) => {
      const target = e.target as HTMLElement;
      if (
        target.closest('.e-prev') ||
        target.closest('.e-next') ||
        target.closest('.e-day.e-title') ||
        target.closest('.e-content.e-decade .e-cell') ||
        target.closest('.e-content.e-year .e-cell') ||
        target.closest('.e-tbar-btn-text') ||
        target.closest('.e-cell')
      ) {
        if (this.langaugeValue === Langauge.TH) {
          setTimeout(() => this.convertThaiYear(), 50);
        }
      }
    });
  }
  /**
   *get appointment list method
   *
   * @memberof PatientAppointmentComponent
   */
   private getStartOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = day === 0 ? 0 : day; 
    return new Date(date.setDate(date.getDate() - diff));
  }
  
  private getEndOfWeek(date: Date): Date {
    const day = date.getDay();
    const diff = day === 0 ? 6 : 6 - day;
    return new Date(date.setDate(date.getDate() + diff));
  }
  public getAppointmentList(values?) {
    let startDate: number, endDate: number;
  
    if (values) {
      const currentDate = new Date(values.currentDate || new Date());
      startDate = Math.floor(this.getStartOfWeek(currentDate).getTime() / 1000); 
      endDate = Math.floor(this.getEndOfWeek(currentDate).setHours(23, 59, 59, 999) / 1000);    
    } else {
      setTimeout(() => {
        const currentViewDates: Date[] = this.scheduleObj.getCurrentViewDates() as Date[];
        const viewStart: Date = currentViewDates[0];
        const viewEnd: Date = currentViewDates[currentViewDates.length - 1];
    
        startDate = Math.floor(this.getStartOfWeek(viewStart).getTime() / 1000); 
        endDate = Math.floor(this.getEndOfWeek(viewEnd).setHours(23, 59, 59, 999) / 1000);   
      }, 1000);
    }
  
    const aptmentTypeValue = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
  setTimeout(() => {
    let url;
    if (
      aptmentTypeValue?.code == OPD_CONST.aptref?.apttypeDeptCode ||
      aptmentTypeValue?.code == OPD_CONST.aptref?.apttTypeHscCode
    ) {
      url = this.appoinmentService.setURlslotData(this, startDate, endDate);
    } else {
      url = this.appoinmentService.setURLmultipleDoctor(this, startDate, endDate);
    }
  
    if (aptmentTypeValue?.id) {
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
          .subscribe((res: any[]) => {
            this.allSlots = res;
            this.events = [];
            if (res != null && res.length > 0) {
              this.weekView(res);
            } else {
              this.setOverViewData(this.events);
            }
          })
      );
    }
  }, 1000);
   
  }
  /**
   *change single to multiple
   *
   * @memberof PatientAppointmentComponent
   */
  changeSingleToMultiple() {
    if (!this.mulipleDoctor) {
      this.apptType = OPD_CONST.aptref.resource;
    } else {
      this.doctorList.forEach((element) => {
        element.slected = "";
      });
      this.multipleDoctorSlected = [];
      this.parentMessage = {
        res: [],
        appointmentType: this.appointmentType,
        doctor: this.activeDoctor,
        department: this.department,
        currentDate: this.currentDate,
      };
      this.apptType = OPD_CONST.aptref.appt;
    }
  }
  /**
   *
   */
  appoinmentSearch() {
    let aptmentTypeDesc = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
    const dialogRef = this.dialog.open(AppointmentQuickSearchComponent, {
      height: "550px",
      width: "550px",
      data: {
        appointmentType: this.appointmentType,
        doctor: this.activeDoctor,
        department: this.department,
        doctorList: this.multiLangDoctorList,
        appointmentDate: OPD_CONST.aptref.selectedDate,
        slotMinutes: OPD_CONST.aptref.slotMints,
        aptmentTypeDesc: aptmentTypeDesc,
        consultationtype: this.teleconsultaion,
        consultationtypeList: this.Teleconsultations,
        departmentList: this.departmentList,
        appointmentTypeList: this.appointmentTypeList,
      },
    });
    this.subscriptionList.add(dialogRef.afterClosed().subscribe(() => {}));
  }
  /**
   *change multipe doctors
   *
   * @memberof PatientAppointmentComponent
   */
  getMultipleDoctors() {
    this.currentDate = this.datepipe.transform(
      new Date(),
      OPD_CONST.aptref.dateFormat
    );
    var docs: any[] = [];
    this.multipleDoctorSlected.forEach((element) => {
      docs.push(element.code);
    });

    if (this.appointmentType.id) {
      let start = (
        new Date(new Date().setHours(0, 0, 0, 0)).getTime() / 1000
      ).toFixed(0);
      let end = (
        new Date(new Date().setHours(23, 59, 0, 0)).getTime() / 1000
      ).toFixed(0);
      let url = this.appoinmentService.setURLmultipleDoctor(this, start, end);
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
          .subscribe((res) => {
            this.parentMessage = {
              res: res,
              appointmentType: this.appointmentType,
              doctor: this.activeDoctor,
              department: this.department,
              currentDate: this.currentDate,
            };
            this.multipleDoctors = res[0].Slots;
          })
      );
    }
  }
  /**
   *Display WeekWise Slot
   *
   * @param {*} data
   * @memberof PatientAppointmentComponent
   */
  weekView(data) {
    let teleConsultaionValue = this.Teleconsultations.find(
      (i) => i.code == this.teleconsultaion
    );
    
    data.forEach((eachDay) => {
      eachDay.Slots.forEach((slot) => {
        if(slot.id) {
          if (slot.businessStatus == OPD_CONST.aptSlotStatus.busy) {
            const patientList = [];
            var mrn: any[] = [];
            var apt: any[] = [];
            if (slot.patientNumber) {
              slot.patientNumber.forEach((element) => {
                if (element.type) {
                  mrn.push(element?.type?.text || '');
                  apt.push({ mar: element?.type?.text || '', apptNo: element.aptNo });
                  patientList.push({
                    mrn: element?.type?.text || '',
                    name: element?.patientName || '',
                    aptNo: element.aptNo || '',
                    contact: element?.contactNo || '',
                    emailid:element?.email|| '',
                    remarks: Array.isArray(element?.remark) ? element.remark.join(', ') : ''
                  }); 
                }
              });
            }
            this.events.push({
              subjectHeader: "Subject ",
              Subject: (this.env.defaultLang =='en_th'?OPD_CONST.aptSlotStatus.Hn:OPD_CONST.aptSlotStatus.mrn) + mrn.toString(),
              StartTime: new Date(slot.start),
              EndTime: new Date(slot.end),
              IsAllDay: false,
              CalendarId: 3,
              Location: "",
              Description: OPD_CONST.aptSlotStatus.eventBooked,
              Id: slot.id,
              patientList: patientList ,
              businessStatus: "BOOK"
            });
          } else if (
            slot.businessStatus.toUpperCase() ==
            OPD_CONST.aptSlotStatus.Hold.toUpperCase()
          ) {
            var reason = slot.hold ? slot.hold.reason[0].display : "";
            var remarks = slot.hold ? slot.hold.remarks : "";
            this.isDisplayRemarks=true;
            this.events.push({
              subjectHeader: "Reason ",
              Subject:reason ,
              remarks:remarks,
              StartTime: new Date(slot.start),
              EndTime: new Date(slot.end),
              DepartmentName: this.department,
              Id: slot.id,
              IsAllDay: false,
              CalendarId: 4,
              Location: "",
              Description: OPD_CONST.aptSlotStatus.eventScheduled,
            });
          } else if (
            slot.businessStatus.toUpperCase() ==
            OPD_CONST.aptSlotStatus.free.toUpperCase()
          ) {
            var currentTime = new Date().getTime() / 1000;
            var currentSlotBlockTime = Number((currentTime + (this.slotBlockDuration*60)));
      
            let aptmentTypeValue = this.appointmentTypeList.find(
              (i) => i.code == this.appointmentType
            );
            if (
              currentTime > slot.startDateTimeEpoch &&
              aptmentTypeValue.code != OPD_CONST.aptref.apttTypeHscCode
            ) {
              var mrn: any[] = [];
              var apt: any[] = [];
              if (slot.patientNumber) {
                slot.patientNumber.forEach((element) => {
                  mrn.push(element.display);
                  apt.push({ mar: element.display, apptNo: element.reference });
                });
              }
              this.events.push({
                subjectHeader: "Subject ",
                Subject: teleConsultaionValue.desc,
                StartTime: new Date(slot.start),
                EndTime: new Date(slot.end),
                DepartmentName: this.department,
                Id: slot.id,
                IsAllDay: false,
                CalendarId: 2,
                Location: "",
                Description: OPD_CONST.aptSlotStatus.eventScheduled,
              });
            } else if (
              currentTime > slot.endDateTimeEpoch &&
              aptmentTypeValue.code == OPD_CONST.aptref.apttTypeHscCode
            ) {
              var mrn: any[] = [];
              var apt: any[] = [];
              if (slot.patientNumber) {
                slot.patientNumber.forEach((element) => {
                  mrn.push(element.display);
                  apt.push({ mar: element.display, apptNo: element.reference });
                });
              }
              this.events.push({
                subjectHeader: "Subject ",
                Subject: teleConsultaionValue ? teleConsultaionValue.desc : "",
                StartTime: new Date(slot.start),
                EndTime: new Date(slot.end),
                DepartmentName: this.department,
                Id: slot.id,
                IsAllDay: false,
                CalendarId: 2,
                Location: "",
                Description: OPD_CONST.aptSlotStatus.eventScheduled,
              });
            } else if(slot.startDateTimeEpoch < currentSlotBlockTime) {
              this.events.push({
                subjectHeader: "Subject ",
                Subject: OPD_CONST.aptSlotStatus.blocked,
                StartTime: new Date(slot.start),
                EndTime: new Date(slot.end),
                IsAllDay: false,
                CalendarId: 4,
                Location: "",
                Description: OPD_CONST.aptSlotStatus.eventBooked,
                Id: slot.id,
              });
              slot.tempStatus=OPD_CONST.aptSlotStatus.blocked;
            } else {
              var minutesToAdd = this.blockTime;
              var currentDate = new Date();
              var currentTimeappconfig =
                Number(new Date(currentDate.getTime() + minutesToAdd * 60000)) /
                1000;
              if (
                currentTimeappconfig > slot.startDateTimeEpoch &&
                aptmentTypeValue.code != OPD_CONST.aptref.apttTypeHscCode
              ) {
                var mrn: any[] = [];
                var apt: any[] = [];
                if (slot.patientNumber) {
                  slot.patientNumber.forEach((element) => {
                    mrn.push(element.display);
                    apt.push({ mar: element.display, apptNo: element.reference });
                  });
                }
                this.events.push({
                  subjectHeader: "Subject ",
                  Subject: teleConsultaionValue.desc,
                  StartTime: new Date(slot.start),
                  EndTime: new Date(slot.end),
                  Id: slot.id,
                  IsAllDay: false,
                  CalendarId: 2,
                  Location: "",
                  Description: OPD_CONST.aptSlotStatus.eventScheduled,
                  DepartmentName: this.department.desc,
                });
              } else {
                var mrn: any[] = [];
                var apt: any[] = [];
                var patientList: any[] = [];
                if (slot.patientNumber) {
                  slot.patientNumber.forEach((element) => {
                    let mrnNo = element?.type?.text ?? ''
                    mrn.push( (this.env.defaultLang =='en_th'?OPD_CONST.aptSlotStatus.Hn:OPD_CONST.aptSlotStatus.mrn) + mrnNo);
                    apt.push({ mar: element.type.text, apptNo: element.value });
                    patientList.push({
                      mrn: element?.type?.text || '',
                      name: element?.patientName || '',
                      aptNo: element.aptNo || '',
                      contact: element?.contactNo || '',
                      emailid:element?.email|| '',
                      remarks: Array.isArray(element?.remark) ? element.remark.join(', ') : ''
                    });
                  });
                  
                }
                this.events.push({
                  subjectHeader: "Subject ",
                  Subject:
                    mrn.length > 0
                      ? mrn.toString()
                      : teleConsultaionValue
                      ? teleConsultaionValue.desc
                      : "",
                  StartTime: new Date(slot.start),
                  EndTime: new Date(slot.end),
                  Id: slot.id,
                  IsAllDay: false,
                  CalendarId: slot.multipleBookingsAllowed && slot.totalCurrentBookings > 0 ? 5 : 1,
                  Location: "",
                  Description: OPD_CONST.aptSlotStatus.eventScheduled,
                  DepartmentName: this.department.desc,
                  patientList: patientList || [] 
                });
              }
            }
          }
        }
      });
    });
    this.setOverViewData(this.events);
  }
onEventRendered(args: any): void {
  if (
    args.data.Subject &&
    args.data.CalendarId === 5 &&
    Array.isArray(args.data.patientList) &&
    args.data.patientList.length > 0
  ) {
    const element = args.element.querySelector('.e-subject') as HTMLElement;
    if (element) {
      element.style.color = 'blue';
      element.style.cursor = 'pointer';
      element.style.textDecoration = 'underline';

      element.onclick = (ev) => {
        ev.stopPropagation();
        this.subjectClicked = true;
        this.onMrnClick(args.data);
      };
    }
  }
}

onMrnClick(eventData: any) {
  if (eventData.CalendarId === 5 && eventData.patientList?.length) {
    this.scheduleObj.openQuickInfoPopup(eventData);
  }
}
  /**
   *set over view data
   *
   * @param {any[]} events
   * @memberof PatientAppointmentComponent
   */
  setOverViewData(events: any[]) {
    const overviewEvents: { [key: string]: Date }[] = extend(
      [],
      events,
      null,
      true
    ) as { [key: string]: Date }[];
    const timezone: Timezone = new Timezone();
    const utcTimezone: never = OPD_CONST.aptref.utc as never;
    const currentTimezone: never = timezone.getLocalTimezoneName() as never;
    for (const event of overviewEvents) {
      event["StartTime"] = timezone.convert(
        event["StartTime"],
        utcTimezone,
        currentTimezone
      );
      if (event["EndTime"]) {
        event["EndTime"] = timezone.convert(
          event["EndTime"],
          utcTimezone,
          currentTimezone
        );
      }
    }
    this.eventSettings = { dataSource: overviewEvents };
  }
  /**
   *event clcik method
   *
   * @param {*} jsEvent
   * @memberof PatientAppointmentComponent
   */
  eventClick(jsEvent) {
    let currentDate =new Date();
    if(this.isOverRightBlockedSlot && jsEvent.CalendarId != 3 && jsEvent.CalendarId != 1 && !this.unHold && !this.isHold
      && jsEvent.StartTime>=currentDate
    ){
      let aptmentTypeDesc = this.appointmentTypeList.find(
        (i) => i.code == this.appointmentType
      );
      let dateId=this.datepipe.transform(jsEvent.StartTime, 'yyyy-MM-dd');
      var slots: any[] = [];
      this.allSlots.forEach((element) => {
        if (element._id == dateId) {
          slots = element.Slots;
        }
      });
      const dialogRef = this.dialog.open(DialogAddAppointmentPatient, {
        width: OPD_CONST.aptref.width,
        height:"auto",
        data: {
          appointmentDate: OPD_CONST.aptref.selectedDate,
          slotMinutes: OPD_CONST.aptref.slotMints,
          slotId: jsEvent.Id,
          selectedDay: dateId,
          daySlot: slots,
          appointmentType: this.appointmentType,
          aptmentTypeDesc: aptmentTypeDesc,
          doctor: this.activeDoctor,
          department: this.department,
          consultationtype: this.teleconsultaion,
          consultationtypeList: this.Teleconsultations,
          calenderEvent: jsEvent,
          doctorList: this.multiLangDoctorList,
          departmentList: this.departmentList,
          appointmentTypeList: this.appointmentTypeList,
          blocktime: (this.slotBlockDuration * 60),
          reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
          waitingPatient:this.waitingPatient
        },
      });
      this.subscriptionList.add(
        dialogRef.afterClosed().subscribe(() => {
          this.getAppointmentList();
        })
      );
    }else{
    if (
      (jsEvent.CalendarId == 1 && jsEvent.Id) ||
      (jsEvent.CalendarId == 4 && jsEvent.Id) ||
      (jsEvent.CalendarId == 5 && jsEvent.Id)
    ) {
      if (this.isHold) {
        if (jsEvent.CalendarId != 4) {
          const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
            width: "20%",
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe((result) => {
              if (result.action == "yes") {
                let reqpaylad = {
                  ids: [jsEvent.Id ? jsEvent.Id : 0],
                  remarks: result.remarks ? result.remarks : "",
                  reason: result.reason
                    ? this.langService.createObjectList(result.reason[0])
                    : [],
                  status: "HOLD",
                };
                this.subscriptionList.add(
                  this.generalApiService
                    .putTypeApi(
                      OPD_API_URL.OPD_SERVICE,
                      OPD_API_URL.OPD_APPOINTMENT_HOLD,
                      reqpaylad
                    )
                    .subscribe((response: any) => {
                      if (response) {
                        this.snackBar.open(
                          this.langService.get("CommonAppoinment.success"),
                          "Hold Slot Successfully",
                          {
                            duration: 3000,
                          }
                        );
                      }
                      this.getAppointmentList();
                    })
                );
              }
            })
          );
        }
      } else if (this.unHold) {
        if (jsEvent.CalendarId == 4) {
          const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
            width: "20%",
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe((result) => {
              if (result.action == "yes") {
                let reqpaylad = {
                  ids: [jsEvent.Id ? jsEvent.Id : 0],
                  remarks: result.remarks ? result.remarks : "",
                  reason: result.reason
                    ? this.langService.createObjectList(result.reason[0])
                    : [],
                  status: "UNHOLD",
                };
                this.subscriptionList.add(
                  this.generalApiService
                    .putTypeApi(
                      OPD_API_URL.OPD_SERVICE,
                      OPD_API_URL.OPD_APPOINTMENT_HOLD,
                      reqpaylad
                    )
                    .subscribe((response: any) => {
                      if (response) {
                        this.snackBar.open(
                          this.langService.get("CommonAppoinment.success"),
                          "UnHold Slot Successfully",
                          {
                            duration: 3000,
                          }
                        );
                      }
                      this.getAppointmentList();
                    })
                );
              }
            })
          );
        } else {
          this.snackBar.open(
            this.langService.get("CommonAppoinment.warning"),
            "Please Selct the Hold slots only",
            {
              duration: 3000,
            }
          );
        }
      } else {
        if (jsEvent.CalendarId != 4) {
          let aptmentTypeDesc = this.appointmentTypeList.find(
            (i) => i.code == this.appointmentType
          );
          // let dateId = this.datepipe.transform(
          //   jsEvent.StartTime,
          //   OPD_CONST.aptref.jsDateFormat
          // );
          let dateId=this.datepipe.transform(jsEvent.StartTime, 'yyyy-MM-dd');
          var slots: any[] = [];
          this.allSlots.forEach((element) => {
            if (element._id == dateId) {
              slots = element.Slots;
            }
          });
          const dialogRef = this.dialog.open(DialogAddAppointmentPatient, {
            width: OPD_CONST.aptref.width,
            height:"auto",
            data: {
              appointmentDate: OPD_CONST.aptref.selectedDate,
              slotMinutes: OPD_CONST.aptref.slotMints,
              slotId: jsEvent.Id,
              selectedDay: dateId,
              daySlot: slots,
              appointmentType: this.appointmentType,
              aptmentTypeDesc: aptmentTypeDesc,
              doctor: this.activeDoctor,
              department: this.department,
              consultationtype: this.teleconsultaion,
              consultationtypeList: this.Teleconsultations,
              calenderEvent: jsEvent,
              doctorList: this.multiLangDoctorList,
              departmentList: this.departmentList,
              appointmentTypeList: this.appointmentTypeList,
              blocktime: (this.slotBlockDuration * 60), //this.minutesblock,
              reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
              waitingPatient:this.waitingPatient
            },
          });
          this.subscriptionList.add(
            dialogRef.afterClosed().subscribe(() => {
              this.getAppointmentList();
            })
          );
        }
      }
    } else if (jsEvent.CalendarId == 3) {
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_APPOINTMENT_FILTER + jsEvent.event.apptNo[0].apptNo
          )
          .subscribe((res) => {
            this.details = {
              name: res[0].subject.display,
              gender: res[0].temporaryPatient[0].gender.desc,
              doctor: res[0].entity.display,
              department: res[0].specialty[0].text,
              appointment: res[0].start,
              mrnNumber: res[0].temporaryPatient[0].TRN,
              mobile: res[0].temporaryPatient[0].mobileNo,
              photo: res[0].temporaryPatient[0].photo,
              id: res[0].temporaryPatient[0].idType.desc,
              idno: res[0].temporaryPatient[0].idNumber,
              email: res[0].temporaryPatient[0].email,
              company: res[0].company ? res[0].company.display : "",
              ref: res[0].referralEntityType
                ? res[0].referralEntityType.display
                : "",
              refType: res[0].referralEntityName
                ? res[0].referralEntityName.display
                : "",
              bookingType: res[0].bookingType ? res[0].bookingType.display : "",
              appno: res[0].identifier[0].value,
            };

            this.dialog.open(AppointmentDetailsComponent, {
              width: OPD_CONST.aptref.dialogWidth,
              data: {
                details: this.details,
                allAppointment: jsEvent.event.apptNo,
              },
            });
          })
      );
    } else {
      if (jsEvent.Id) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.slotIsAlreadybooked"),
          {
            duration: 3000,
          }
        );
      }
    }
  }
  }
  /**
   *set date header method
   *
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  setDateHeader() {
    const elementHead = document.getElementsByClassName(
      OPD_CONST.aptref.fcCenter
    )[0];
    if (elementHead) {
      this.currentDate = elementHead.children.item(0).innerHTML;
      return elementHead.children.item(0).innerHTML;
    }
  }
  /**
   *seclet type method
   *
   * @memberof PatientAppointmentComponent
   */
  selectType() {
    let rescheduleData = JSON.parse(
      localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)
    );
    this.appointmentType = this.appointmentTypeList.find(
      (i) => i.code == rescheduleData.appointmentType
    );
    this.appointmentTypeChange(Number(this.appointmentType.code));
    this.checkRequestHasRecschedule();
  }
  /**
   *appointment type change method
   *
   * @param {*} event
   * @memberof PatientAppointmentComponent
   */
  public appointmentTypeChange(value) {
    this.activeDoctor.code = "";
    this.activeDoctor.id = "";
    this.activeDoctor.name = "";
    this.activeDoctor.department = "";
    this.activeDoctor.email = "";
    this.doctorList = [];
    this.multiLangDoctorList = [];
    this.doctorsCount = "";
    this.events = [];
    this.setOverViewData(this.events);
    if (value == 1) {
      this.doctorList = [];
      this.multiLangDoctorList = [];
      this.multiDocCheckbox = false;
      this.teleconsultaion = {};
      this.multiDocCheckbox = true;
      this.department = {};
      this.isConsultationVisible=true;
    } else {
      this.doctorList = [];
      this.multiLangDoctorList = [];
      this.teleconsultaion = {};
      this.department = {};
    }

    if (value == 3) {
      this.isPermission = false;
      this.isDoctorVisible = false;
      this.isConsultationVisible=false;
      this.getDepartment(false);
    } else if (value == 2) {
      this.isPermission = true;
      this.isDoctorVisible = false;
      this.isConsultationVisible=true;
    } else
    {  
      this.isPermission = true;
      this.isDoctorVisible = true;
      this.isConsultationVisible=true;
    }
  }

  /**
   *consultaoin change method
   *
   * @param {*} teleconsultaion
   * @param {*} isReschedule
   * @memberof PatientAppointmentComponent
   */
  public consultationOnchange(teleconsultaion, isReschedule) {
    if (isReschedule) {
      teleconsultaion == OPD_CONST.aptref.clinicCode
        ? this.getDepartment(false)
        : this.getDepartment(true);
    } else {
      // if (teleconsultaion.value == OPD_CONST.aptref.clinicCode) {
      //   this.getDepartment(false);
      //   this.multiDocCheckbox = true;
      // } else {
      //   this.getDepartment(true);
      //   this.multiDocCheckbox = true;
      // }
      this.getDepartment(teleconsultaion.value);
      this.multiDocCheckbox = true;
    }
  }

  /**
   *get appointmenttype master data
   *
   * @memberof PatientAppointmentComponent
   */
  public getAppointmentTypeMaster() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_APPOINTEMENT_TYPE,true)
        .subscribe((data: any) => {
          this.appointmentTypeList = data;
          this.filteredappointmentType.next(this.appointmentTypeList.slice());
          if (this.defaultApptType && !this.isFromWaitingList) {
            this.appointmentType = this.defaultApptType;
            this.appointmentTypeCtrl.setValue(this.defaultApptType);
          }
          if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
            this.selectType();
        })
    );
  }
  /**
   *get appointmentTeleconsultation master data
   *
   * @memberof PatientAppointmentComponent
   */
  getTeleApptype() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_TELE_APPOINTMENT_TYPE,true)
        .subscribe((data: any) => {
          this.Teleconsultations = data;
          this.filteredTelecom.next(this.Teleconsultations.slice());
          if (this.defaultConsultationType && !this.isFromWaitingList) {
            this.teleconsultaion = this.defaultConsultationType;
            this.teleCtrl.setValue(this.defaultConsultationType);
          }
        })
    );
  }
  /**
   *get department master data
   *
   * @param {*} isClinicConsultation
   * @memberof PatientAppointmentComponent
   */
  public getDepartment(isClinicConsultation) {
    this.customArray = [];
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_DEPT)
        .subscribe((data) => {
          if (data && data.length > 0) {
            // isClinicConsultation == true
            //   ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
            //   : (this.departmentList = data.filter((dept: any) => dept.isClinicalSpeciality === true));
             if (isClinicConsultation == OPD_CONST.aptref.clinicCode) {
            this.departmentList = data.filter((dept: any) => dept.isClinicalSpeciality === true);
          } else if (isClinicConsultation == OPD_CONST.aptref.dischargePhoneCallCode) {
            this.departmentList = data.filter((i) => i.isDischargePhoneCall);
          } else {
            isClinicConsultation == true
              ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
              : (this.departmentList = data.filter((dept: any) => dept.isClinicalSpeciality === true));
            // this.departmentList = data.filter((i) => i.isTeleconsultation);
          }
          }
          if (data != null && data.length > 0) {
            this.initAutoComplete();
            this.selectDepartment();
            this.filteredDepts.next(this.departmentList.slice());
            if(this.isReschedule){
               this.deptCtrl.setValue(this.department);
               let departmentvalue={value:this.department}
               this.departmentOnChange(departmentvalue,false, true);
            }else{
            if (this.defaultDept) {
              this.department = this.defaultDept;
              this.deptCtrl.setValue(this.defaultDept);
             }
              this.departmentOnChange(
                { value: this.defaultDept },
                false, true
              );
            }
          }
        })
    );
  }

  public getDepartmentValue(isClinicConsultation) {
    this.customArray = [];
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_DEPT)
        .subscribe((data) => {
          if (data && data.length > 0) {
            isClinicConsultation == true
              ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
              : (this.departmentList = data);
          }
        })
    );
  }
  /**
   *select department method
   *
   * @memberof PatientAppointmentComponent
   */
  selectDepartment() {
    if (localStorage.getItem(OPD_CONST.aptref.rescheduleApp)) {
      const appointment = JSON.parse(
        localStorage.getItem(OPD_CONST.aptref.rescheduleApp)
      );
      this.department = this.departmentList.find(
        (i) => i.desc == appointment.specialty
      );
      this.department.value = {
        code: this.department.code,
      };
    }
  }

  onChanges() {
    if (this.doctorList.length > 0) {
      this.subscriptionList.add(
        this.deptFilterCtrl.valueChanges.subscribe((value) => {
          this.doctorFilteredList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
      this.subscriptionList.add(
        this.appointmentTypeDFltrCtrl.valueChanges.subscribe((value) => {
          this.doctorList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
    }
  }
  /**
   *department change method
   *
   * @param {*} department
   * @param {*} isReschedule
   * @memberof PatientAppointmentComponent
   */
  public departmentOnChange(department, isReschedule, reset = true,searchWaitingDoctor = false) {
    this.deptFlag = true;
    this.isQuickSearch = false;
    if (reset) {
      this.offset = 0;
      this.doctorList = [];
      this.multiLangDoctorList = [];
    }
    if (this.appointmentType == OPD_CONST.aptref.aptTypeCode) {
      let payload;
      if (isReschedule) {
        payload = {
          unitCode: this.unitCode,
          departmentCode: department,
          isIncludeDoctorSlot: true,
          typeCodeList: ["DR"],
          doctorName: this.doctorSearch?.trim() || "",
          // l2: this.langaugeValue === 'th' ? this.doctorSearch?.trim() || "" : "",
          offset: this.offset,
          limit: this.limit
        };
      } else {
        payload = {
          unitCode: this.unitCode,
          departmentCode: department.value,
          isIncludeDoctorSlot: true,
          typeCodeList: ["DR"],
          doctorName: searchWaitingDoctor
            ? this.waitingPatient?.doctor?.display?.trim() || ""
            : this.doctorSearch?.trim() || "",
          // l2: this.langaugeValue === 'th' ? this.doctorSearch?.trim() || "" : "",
          offset: this.offset,
          limit: this.limit
        };
      }
      this.subscriptionList.add(
        this.masterApiService
          .postTypeMaster(OPD_API_URL.EMPLOYEE_LIST_NEW, payload)
          .subscribe((content: any) => {
            this.totalElements = content.payload.totalElements;
            let data =
              content.payload && content.payload.employeeResponseList
                ? content.payload.employeeResponseList
                : [];
            let list = [];
            let letmultilangdoclist = [];
            if (data != null && data.length > 0) {
              data.forEach((element) => {
                list.push({
                  id: element.id,
                  code: element.code,
                  desc: this.langaugeValue == 'th'?element.l2:element.desc,
                  gender: element.gender?.toUpperCase() ?? "",
                 // imagePath: this.getImage(element.empImagePath, element.code),
                 imagePath:element.aws3FilePath ? element.aws3FilePath : (element.empImagePath ?this.imageUrl+element.empImagePath : ""),
                 available:
                    element.doctoreAvailable == OPD_CONST.noSlotsAvailable
                      ? this.langService.get("AppointmentListPage.noSlotsAvailable")
                      : this.langService.get("AppointmentListPage.nextAvailability") + element.doctoreAvailable,
                  doctoreAvailableDate:element.doctoreAvailable
                });
                letmultilangdoclist.push(element);
              });
            }
            // this.multiLangDoctorList = letmultilangdoclist;
            // this.doctorFilteredList = list;
            // this.doctorList = list;
            // this.docList = list;
            if (this.offset === 0) {
              this.multiLangDoctorList = letmultilangdoclist;
              this.doctorFilteredList = list;
              this.doctorList = list;
              this.docList = list;
            } else {
              this.multiLangDoctorList = [...this.multiLangDoctorList,...letmultilangdoclist];
              this.doctorFilteredList = [...this.doctorFilteredList, ...list];
              this.doctorList = [ ...this.doctorList, ...list];
              this.docList = [ ...this.docList, ...list ];
            }
            // this.doctorsCount =
            //   this.doctorList.length > 0 ? this.doctorList.length : "";
            this.doctorsCount = this.totalElements.toString();
              this.filteredDocsList = [...this.doctorList];
            this.filteredDocs.next(this.doctorList.slice());
            let docValue
            if (isReschedule) {
              docValue = this.doctorList.find(
                (i) => i.code == this.IsRescheduleData.doctorCode
              );
              // this.doctorOnChange(docValue);
              if (docValue) {
                this.doctorOnChange(docValue);
              } else if (this.doctorList.length < this.totalElements) {
                this.offset++;
                this.departmentOnChange(department, true, false);
                return;
              }
            } else   if(this.isFromWaitingList){
              docValue=this.doctorList.find(
                (i) => i.code == this.waitingPatient.doctor.code
              );
              // this.doctorOnChange(docValue);
              if (docValue) {
                this.doctorOnChange(docValue);
              } else if (!searchWaitingDoctor) {
                this.offset = 0;
                this.departmentOnChange(department, false, false,true);
                return;
              }
            }else{
              this.refreshSchedule();
              if (this.langaugeValue === 'th') {
                setTimeout(() => this.convertThaiYear(), 50);
              }
            }
          this.isLoadingDoctors = false;
          })
      );
    } else {
      this.getAppointmentList();
    }
  }

  filterDoctorList(): void {
    // const search = this.doctorSearch.toLowerCase();

    // if (!search) {
    //   this.filteredDocsList = this.doctorList;
    //   return;
    // }

    // this.filteredDocsList = this.doctorList.filter((doctor) =>
    //   doctor.desc.toLowerCase().includes(search)
    // );
    this.offset = 0;
    this.doctorList = [];
    this.filteredDocsList = [];

    if (this.isReschedule) {
      this.departmentOnChange(this.department, true, true);
    } else {
      this.departmentOnChange({ value: this.department }, false, true);
    }

  }
  /**
   *
   * @param path
   * @param code
   */
  getImage(path, code) {
    if (path) {
      let resPath = path.replace("/file-service/", "");
      this.subscriptionList.add(
        this.generalApiService
          .getTypeApi(OPD_API_URL.FILE_SERVICE, resPath)
          .subscribe((res: any) => {
            if (res) {
              this.doctorList.forEach((element) => {
                if (element.code == code) {
                  element.imagePath = res.url ? res.url : "";
                }
              });
            }
          })
      );
    }
  }
  /**
   *doctor change method
   *
   * @param {*} doctor
   * @memberof PatientAppointmentComponent
   */
  public doctorOnChange(doctor) {
    if (this.mulipleDoctor) {
      doctor.slected = OPD_CONST.aptref.active;
      var slecteDoctors = this.doctorList.filter((doctor) => {
        return doctor.slected == OPD_CONST.aptref.active;
      });
      this.multipleDoctorSlected = slecteDoctors;
      this.getMultipleDoctors();
    } else {
      this.deptFlag = false;
      this.activeDoctor.id = doctor.id;
      this.activeDoctor.code = doctor.code;
      this.activeDoctor.name = doctor.desc;
      this.activeDoctor.email = doctor.email ? doctor.email : "";
      this.doctor = doctor;
      this.searchResult.doctor = doctor.name;
      const availableDate = this.parseAvailableDate(doctor.doctoreAvailableDate);

      if (availableDate) {
        this.scheduleObj.selectedDate = availableDate;
        this.getAppointmentList({ currentDate: availableDate });
      }
      else {
        this.refreshSchedule();
      }
      if (this.langaugeValue === 'th') {
        setTimeout(() => this.convertThaiYear(), 50);
      }
  }
  }
  parseAvailableDate(dateStr: string): Date | null {
    const match = dateStr.match(/(\w+),(\w+ \d+)/);
    if (!match) {
      return null;
    }
    const currentYear = new Date().getFullYear();
    const formattedDateStr = `${match[2]} ${currentYear}`;
    const parsedDate = new Date(formattedDateStr);
  
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }
  public refreshSchedule() {
    this.allSlots = []; 
    this.events = [];
    const currentDate = new Date();
    this.scheduleObj.selectedDate = new Date(currentDate);
    this.scheduleObj.refresh(); 
    this.setOverViewData(this.events);
   
  }
  /**
   *time stamp method
   *
   * @param {*} strDate
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum / 1000;
  }
  /**
   *Check reques appoinment
   *
   * @memberof PatientRegistrationComponent
   */
  checkRequestHasRecschedule() {
    if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)) {
      let appointment: any = JSON.parse(
        localStorage.getItem(OPD_CONST.appoinmentRef.aptResData)
      );
      if (appointment && appointment.type == OPD_CONST.appoinmentRef.temp) {
        this.isReschedule = true;
        this.appointmentType = appointment.appointmentType;
        this.teleconsultaion = "CC";
        this.consultationOnchange(this.teleconsultaion, true);
        this.department = appointment.departmentCode;
        this.departmentOnChange(this.department, true, true);
        this.IsRescheduleData = appointment;
      } else if (
        appointment &&
        appointment.type == OPD_CONST.appoinmentRef.reg
      ) {
        this.isReschedule = true;
        this.appointmentType = appointment.appointmentType;
        this.teleconsultaion = "CC";
        this.consultationOnchange(this.teleconsultaion, true);
        this.department = appointment.departmentCode;
        this.departmentOnChange(this.department, true, true);
        this.IsRescheduleData = appointment;
      }
    }
  }

  recurringAppointments(){
    let aptmentTypeDesc = this.appointmentTypeList.find(
      (i) => i.code == this.appointmentType
    );
    let dateId=this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    var slots: any[] = [];
    this.allSlots.forEach((element) => {
      if (element._id == dateId) {
        slots = element.Slots;
      }
    });

    const dialogRef = this.dialog.open(RecurringAppointmentsComponent, {
      width: OPD_CONST.aptref.width,
      height:"auto",
      data: {
        appointmentDate: OPD_CONST.aptref.selectedDate,
        slotMinutes: OPD_CONST.aptref.slotMints,
        slotId: 0,
        selectedDay: dateId,
        daySlot: this.allSlots,
        appointmentType: this.appointmentType,
        aptmentTypeDesc: aptmentTypeDesc,
        doctor: this.activeDoctor,
        department: this.department,
        consultationtype: this.teleconsultaion,
        consultationtypeList: this.Teleconsultations,
        calenderEvent: null,
        doctorList: this.multiLangDoctorList,
        departmentList: this.departmentList,
        appointmentTypeList: this.appointmentTypeList,
        blocktime: (this.slotBlockDuration * 60),
        reScheduleData: this.isReschedule ? this.IsRescheduleData : "",
        isReschedule: this.isReschedule,
        waitingPatient:this.waitingPatient
      },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe(() => {
        this.getAppointmentList();
      })
    );
  }

   setViewOptions(): void {
    this.langService.translate.stream([
      'Scheduler.Day',
      'Scheduler.Week',
      'Scheduler.WorkWeek',
      'Scheduler.Month'
    ]).subscribe(translations => {
      this.viewOptions = [
        { option: 'Day', label: translations['Scheduler.Day'] },
        { option: 'Week', label: translations['Scheduler.Week'] },
        { option: 'WorkWeek', label: translations['Scheduler.WorkWeek'] },
        { option: 'Month', label: translations['Scheduler.Month'] }
      ];
    });
  }
  convertThaiYear(): void {
  if (this.langaugeValue !== Langauge.TH) return;

  setTimeout(() => {
    const convertTextYear = (el: HTMLElement) => {
      let text = el.textContent;
      if (text) {
        // Match ALL 4-digit years
        const yearMatches = text.match(/\b\d{4}\b/g);
        if (yearMatches) {
          yearMatches.forEach((match) => {
            const year = parseInt(match, 10);
            if (year < 2500) {
              const thaiYear = year + 543;
              text = text!.replace(match, thaiYear.toString());
            }
          });
          // Replace "ค.ศ." with "พ.ศ."
          text = text.replace('ค.ศ.', 'พ.ศ.');
          el.textContent = text;
        }
      }
    };

    const convertTitleYear = (el: HTMLElement) => {
      let title = el.getAttribute('title');
      if (title) {
        const yearMatches = title.match(/\b\d{4}\b/g);
        if (yearMatches) {
          yearMatches.forEach((match) => {
            const year = parseInt(match, 10);
            if (year < 2500) {
              const thaiYear = year + 543;
              title = title!.replace(match, thaiYear.toString());
            }
          });
          el.setAttribute('title', title);
        }
      }
    };

    // Convert text-based years (all elements where years appear)
    document.querySelectorAll<HTMLElement>(
      `.e-day.e-title,
       .duration-text,
       .e-date-range .e-tbar-btn-text,
       .e-calendar .e-header .e-title,
       .e-calendar .e-content td,
       .e-datepicker .e-header .e-title,
       .e-header.e-year .e-day.e-title`
    ).forEach(convertTextYear);

    // Convert tooltips
    document.querySelectorAll<HTMLElement>('.e-day').forEach(convertTitleYear);

    // Translate static labels
    document.querySelectorAll<HTMLElement>('.quick-info-title').forEach((el) => {
      const txt = el.textContent?.trim();
      if (txt === 'Please select another slot') {
        el.textContent = 'กรุณาเลือกช่วงเวลาอื่น';
      }
      if (txt === 'Appointment Details') {
        el.textContent = 'รายละเอียดการนัดหมาย';
      }
    });
  });
}
  loadNextDoctors() {
    if (this.isLoadingDoctors) {
      return;
    }
    if (this.doctorList.length >= this.totalElements) {
      return;
    }
    this.isLoadingDoctors = true;
    this.offset++;
    this.departmentOnChange({ value: this.department }, false, false);
  }
  onDoctorScroll(event: any) {
    const element = event.target;
    const atBottom =
      element.scrollHeight - element.scrollTop <=
      element.clientHeight + 20;
    if (atBottom) {
      this.loadNextDoctors();
    }
  }
}

export class SearchControl {
  type: string = "";
  placeholder: string = "";
  value: any = {};
  column: number = 6;
  name: string = "";
  url: string = "";
  selectType: string = "";
  radios: string = "";
  methodName: string = "";
  options: any[] = [];
  masterList: any[] = [];
  searchValue:string="";
  isTodaysDate:string="";
}

@Component({
  selector: "app-dilog",
  templateUrl: "./appt-form.html",
  styleUrls: ["./appt-form.scss"],
  providers: [DatePipe],
})
export class DialogAddAppointmentPatient implements OnInit, OnDestroy {
   _onDestroy: Subject<boolean> = new Subject<boolean>();
  primaryIdList: any[] = [];
  slotId: string;
  slotLoadFlag = true;
  patientType = "new";
  selectedDate = "";
  values: any = {};
  saveAction: boolean = false;
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  maxDate = new Date(this.year, this.month, this.day);
  public isPatientNew = true;
  public disableForm = false;
  primaryIdRegex: string = "[A-Za-z0-9]*";
  appointmentForm: FormGroup ;
  public patient: any = {};
  public environment: any = opdEnvironment;
  public mobile = "";
  public patientId = "";
  public isReschedule = false;
  timeSlotList: any = [];
  timeSlotsArray: any = [];
  breakTimes: any = [];
  passD = new Date();
  passYear = this.passD.getFullYear();
  minDateexp = new Date();
  maxDateexp = new Date(this.passYear + 11, 0, 0);
  unitId: any;
  unitCode: any;
  orgId: any;
  appointmentDate: any;
  resultFound: boolean = false;
  displayedColumns: any;
  dataSource = new MatTableDataSource<any>();
  recordsLength: any;
  searchList: any[]=[];
  patientList: any;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  public dropdownValues: any = {};
  slectedSlotId: any[] = [];
  idNumberLength: any = "14";
  error: any = { isError: false, errorMessage: "" };
  bookingDetails: any;
  private subscriptionList = new Subscription();
  apptType: any;
  dilogData: any;
  selectedSlots: any = {};
  dayslots: any[] = [];
  langValue: string = "";
  masterAPI: any = MASTERSSERVICES;
  showExpirDatePicker: boolean = false;
  isHsc: boolean = false;
  patientSearch: FormControl = new FormControl();
  patientFilter: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subdistPrimaryList: any[] = [];
  defaultCountry: string = "";
  isGetAddress: boolean = false;
  isAddeassByPostCode: boolean = false;
  genderValue: any = null;
  primaryValue: any = null;
  prefixValue: any = null;
  specialReq: any;
  mobileCodeValue: any = null;
  date = new Date();
  mindate = new Date(1920, 0, 1);
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  autoRescheduleData: any;
  FormRequiredFelds: any = {
    emailRequired: false,
    handphoneRequired: false,
    officeRequired: false,
    homeReqired: false,
    patientRequired: false,
    bookingTypeRequired: false,
    refTypeRequired: false,
    refRequired: false,
    companyRequired: false,
    subSepcilityRequired: false,
  };
  Data: Array<any> = [];
  checkArray: any[] = [];
  selectedPatient: any;
  patientTypeCat: any = OPD_CONST.aptref.new;
  reschRemarks: any;
  reason: any;
  reasonList: any[] = [];
  base64textString: any;
  imageUser: any;
  healthPackageList: any[] = [];
  healthPackage: any;
  checkedPackageList: any[] = [];
  primaryIdentifierListModified: boolean = false;
  patientInfoDisplay: string = "";
  searchCriteria: any = null;
  refreshTime: string = "";
  hidePatientSearch = false;
  isPatientEditRights: boolean = false;
  isRegistered: boolean = false;
  patientImage: any;
  mrn: string;
  isDisabled: boolean = false;
  isVip:boolean=false;
  isNoteVisible?:string
  specialReqList:any=[]=[];
  patientData:boolean=false;
  reasons: any[]=[];
  reasonSearch: FormControl = new FormControl();
  mobileNoMax: number=14;
  mobileNoMin: number=8;
  defaultGender: dataObj;
  prefixCodeList: baseObj[] = [];
  gender: string;
  isOverRightBlockedSlot: boolean=false;
  loadingData: boolean=false;
  offset: number=0;
  limit: number=10;
  partientSearch: { 
    MRN: string; 
    PatientName: string; 
    identificationType: string; 
    identificationNumber: string; 
    MobileNo: string; 
    birthDate: string; 
    offset: number; 
    limit: number; 
    patientCategory: string;
  };
  datePreferanceDiaplay:string="";
  isSubmitting: boolean = false;
  // primaryIdFilteredList: any;
  defaultIdentification: string='';
  primaryIdCode: any;
  unitName: string;
  orgCode: string;
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  maxIdentificationLength:number=25;
  minIdentificationLength:number=0;
  primaryIdSearch: FormControl = new FormControl();
  allPrimaryIdList: any[] = [];
  ispatientNameLtwo:boolean=false;
  langaugeValue:string="";
  formattedSelectedDate: string | null = null;
  orgName: string="";
  visitTypeValue:string="";
  patientCategoryValue:string="";
  priorityValue:string="";
  selectedAppointmentDate: string="";
  existingPatientMrn: string="";
  isNeedTranslator: boolean = false;
  public deptCtrl: FormControl = new FormControl();
  public deptFilterCtrl: FormControl = new FormControl();
  public teleConsultCtrl: FormControl = new FormControl();
  public teleFilterCtrl: FormControl = new FormControl();
  public visitType: FormControl = new FormControl();
  public appointmentTypeDFltrCtrl: FormControl = new FormControl();
  public filteredDepts: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredTelecom: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredappointmentType: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public Teleconsultations: any = [];
  public departmentList: any = [];
  public docList: any = [];
  public doctorList: any;
  appointmentTypeList: any;
  doctorFilteredList: any;
  appointmentType: any = {};
  department: any = {};
  isConsultationVisible: boolean = false;
  teleconsultaion: any;
  visitTypeCtrl: any;
  teleTypeCtrl: any;
  deptTypeCtrl: any;
  showPatientPrefix: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<DialogAddAppointmentPatient>,
    @Inject(MAT_DIALOG_DATA) public data: DialogAddAppointmentPatient,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    public loadingBar: LoadingBarService,
    private authService: AuthService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private patientService: PatientService,
    private applicationConfigService: ApplicationConfigService,
    private langService: MultiLanguageService,
    public generalApiServiceapt: GeneralUrlService,
    public masterApiServiceapt: MasterUrlService,
    private appoinmentServiceApt: AppointmentService,
    private reportService: ReportService, 
    private appBaseService: AppBaseService,
    public masterApiService: MasterUrlService,
    private ngxService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef,
    private thConvertService:thEnConverterService,
    public searchHead: SearchHeaderService,
    private router: Router,
  ) {
    this.getUnitData();
    this.dilogData = data;

    this.dilogData.daySlot.forEach((element) => {
      if (element.id == data.slotId) {
        this.slectedSlotId.push(element.id);
        element[OPD_CONST.aptref.selected] = true;
      } else {
        var currentTime = new Date().getTime() / 1000;
        if (currentTime < element.startDateTimeEpoch) {
          var minutesToAdd = this.dilogData.blocktime;
          var currentDate = new Date();
          var cuurentTimeappconfig =
            Number(new Date(currentDate.getTime() + minutesToAdd * 60000)) /
            1000;

          if (cuurentTimeappconfig > element.startDateTimeEpoch) {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = true;
          } else {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = false;
          }
        } else {
          element[OPD_CONST.aptref.selected] = false;
          element[OPD_CONST.aptref.past] = true;
        }
        element[OPD_CONST.aptref.blocked] = element.businessStatus === OPD_CONST.aptSlotStatus.HOLD;
        element[OPD_CONST.aptref.booked] = element.businessStatus === OPD_CONST.aptSlotStatus.busy;
        element[OPD_CONST.aptref.available] = element.businessStatus === OPD_CONST.aptSlotStatus.free;
        if(element.tempStatus){
          element[OPD_CONST.aptref.blocked] = element.tempStatus ===OPD_CONST.aptSlotStatus.blocked;
        }
      }
     
    });

    this.selectedSlots = {
      start: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.StartTime
        : this.dilogData.selectedSlots.start,
      end: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.EndTime
        : this.dilogData.selectedSlots.end,
    };
    if (this.dilogData.isQuickSearch) {
      this.selectedSlots = {
        start: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.start
          : this.dilogData.selectedTime.start,
        end: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.end
          : this.dilogData.selectedTime.end,
      };
      this.slectedSlotId.push(this.dilogData.slotId);
    }
  }
  /**
   *Load metthod of dialog window
   *
   * @memberof DialogAddAppointmentPatient
   */
  ngOnInit() {
    this.getAppointmentTypeMaster();
    this.getDepartment();
    this.getTeleApptype();
    this.initAutoComplete();
    this.langaugeValue=localStorage.getItem("lan");
    this.formattedSelectedDate= this.dilogData?.selectedDay
        ? (this.langaugeValue== Langauge.TH
          ? this.thConvertService.convertToThaiFullDateWithOutTimeddmmyy(this.dilogData?.selectedDay)
          : this.datepipe.transform(this.dilogData?.selectedDay, "dd-MM-yyyy"))
        : null;
    this.selectedAppointmentDate = this.dilogData?.selectedDay? this.datepipe.transform(this.dilogData?.selectedDay, "yyyy-MM-dd") : "";
    this.getPrimaryIdList();  
     this.appointmentForm = this.formBuilder.group({
      IdNumber: [null, [Validators.required,removeSpaces]],
      IdType: ["", Validators.required],
      Title: ["", Validators.required],
      FullName: [null],
      Gender: [""],
      DOB: ["", Validators.required],
      realdob: [true],
      idExpiry: [""],
      Age: [""],
      // Email: [
      //   "",
      //   [
      //     Validators.pattern(
      //       "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"
      //     ),
      //   ],
      Email: [
        "",
        [this.emailOrMaskedValidator()]
      
      ],
      countryCodemobile: ["", [Validators.required]],
      HandPhoneNumber: [null, [Validators.required, removeSpaces]],
      OffciePhoneNumber: [""],
      HomePhoneNumber: [""],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      pincodePrimary:["", [Validators.pattern(/^-?([0-9]\d*)?$/)]],
      addressPrimary: [""],
      CompanyType: [""],
      SubSpecility: [""],
      Remarks: [""],
      firstName:[null],
      middleName:[null],
      lastName:[null],
      mfirstName:[null],
      mmiddleName:[null],
      mlastName:[null],
      visitType: [""],
      teleConsultCtrl:[""],
      deptCtrl:[""],
      patientCategory:[""],
      priority:[""],
      specialInstruction:[""],
      needTranslator: [""],
      translatorLanguage: [""]
    });
    // this.searchList = this.appoinmentServiceApt.appoinmentSearchList(this);
    this.getSearchFilter();
    this.authService.getUnit().then((value: any) => {
      this.unitId = value.unitId;
      this.orgId = value.orgId;
      this.unitCode = value.unitCode;
      this.orgName=value.orgDescription;
    });
    this.langService.getCurrentLanguage().then((val) => {
      this.langValue = val;
      if (this.langValue == "en") this.Data = OPD_CONST.specialReqirements;
      else this.Data = OPD_CONST.specialReqirementsMY;
    });
    this.getCountryList();
    this.getspecialReqList();
    this.getHealthPackgeList();
    this.searchOnChanges();
    this.isHsc =
      this.dilogData.appointmentType == OPD_CONST.aptref.apttTypeHscCode
        ? true
        : false;
    if (this.dilogData.reScheduleData) {
      this.autoRescheduleData = this.dilogData.reScheduleData;
      this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
        ? this.setTempPatient(this.autoRescheduleData)
        : this.setSearch(this.autoRescheduleData,true);
      let patientType =
        this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? OPD_CONST.aptref.new
          : OPD_CONST.appoinmentRef.registred;
      this.patientType = patientType;
      this.patientTypeCat = patientType;
      this.isPatientNew = patientType == OPD_CONST.aptref.new;
       if(this.patientType=="registered"){
          this.appointmentForm.disable();
          this.appointmentForm.get('visitType')?.enable();
          this.appointmentForm.get('Remarks')?.enable();
          this.appointmentForm.get('priority')?.enable();
          this.appointmentForm.get('specialInstruction')?.enable();
          this.appointmentForm.get('needTranslator')?.enable();
         this.appointmentForm.get('translatorLanguage')?.enable();
         this.visitType.disable();
         this.teleConsultCtrl.disable();
         this.deptCtrl.disable();
        }else{
         this.appointmentForm.enable();
         this.visitType.enable();
         this.teleConsultCtrl.enable();
         this.deptCtrl.enable();
        }
        this.visitTypeValue=this.dilogData.reScheduleData.appointmentVisitTypeCode?this.dilogData.reScheduleData.appointmentVisitTypeCode:"";
        this.patientCategoryValue=this.dilogData.reScheduleData.patientCategory?this.dilogData.reScheduleData.patientCategory:"";
        this.priorityValue=this.dilogData.reScheduleData.appointmentPriorityCode?this.dilogData.reScheduleData.appointmentPriorityCode:"";
    }
    if(this.dilogData.waitingPatient?.id){
      setTimeout(() => {
        this.getWaitingpatient();
      }, 1500);
    }
    this.isReschedule = this.dilogData?.isReschedule;
    this.reasonTypeMaster();
    this.onChanges();
    this.authService.getUserInfo().then((value: any) => {
      if (value.userSpecialRightList && value.userSpecialRightList.length > 0) {
        value.userSpecialRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightOverRighteBlockedSlot)
            this.isOverRightBlockedSlot = true;
        });
      }
    });
  } 

public appointmentTypeChange(value: number) {
    if(value === 1){
      this.isConsultationVisible = false;
      this.teleConsultCtrl.enable();
    }
    else if(value === 2){
      this.isConsultationVisible = false;
      this.teleConsultCtrl.enable();
    }
    else if(value === 3){
      this.isConsultationVisible = true;
      this.teleConsultCtrl.disable();
      this.getDepartment(false);
    }
}

  getAppointmentTypeMaster() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_APPOINTEMENT_TYPE,true)
        .subscribe((data: any) => {
          this.appointmentTypeList = data;
          this.filteredappointmentType.next(this.appointmentTypeList.slice());
          // this.visitType = this.dilogData?.appointmentType;
          let appointmentTypeValue = this.appointmentTypeList.find(
            (i) => i.code == this.dilogData?.appointmentType
          );

          this.visitType.setValue(appointmentTypeValue.code);
          this.appointmentTypeChange(Number(appointmentTypeValue.code));

        })
    );
  }
  /**
   *get appointmentTeleconsultation master data
   *
   * @memberof PatientAppointmentComponent
   */
  getTeleApptype() {
    this.subscriptionList.add(
      this.masterApiService
        .getTypeMaster(OPD_API_URL.M_TELE_APPOINTMENT_TYPE,true)
        .subscribe((data: any) => {
          this.Teleconsultations = data;
          this.filteredTelecom.next(this.Teleconsultations.slice());
            let teleconsultationValue = this.Teleconsultations.find(
              (i) => i.code == this.dilogData?.consultationtype
            );
            this.teleConsultCtrl.setValue(teleconsultationValue.code);
          // }
        })
    );
  }
  /**
   *get department master data
   *
   * @param {*} isClinicConsultation
   * @memberof PatientAppointmentComponent
   */
  getDepartment(isClinicConsultation?) {
       this.masterApiService
        .getTypeMaster(this.masterAPI.DEPT_GET_DEPT_BY_UNIT)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((data: any) => {
          if (data && data.length > 0) {
            isClinicConsultation == true
              ? (this.departmentList = data.filter((i) => i.isTeleconsultation))
              : (this.departmentList = data.filter((dept: any) => dept.isClinicalSpeciality === true));
          }
          if (data != null && data.length > 0) {
            this.filteredDepts.next(this.departmentList.slice());
               let departmentValue = this.departmentList.find(
                 (i) => i.code == this.dilogData?.department
               );
               this.deptCtrl.setValue(departmentValue.code);
          }
        })
  }
  

  initAutoComplete() {
    this.filteredDepts.next(this.departmentList.slice());
    this.subscriptionList.add(
      this.deptFilterCtrl.valueChanges.subscribe(() => {
        this.filterDepts();
      })
    );
  }
  protected filterDepts() {
    if (!this.departmentList) {
      return;
    }
    let search = this.deptFilterCtrl.value;
    if (!search) {
      this.filteredDepts.next(this.departmentList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepts.next(
      this.departmentList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter doctors method
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterDoc() {
    if (!this.docList) {
      return;
    }
    let search = this.appointmentTypeDFltrCtrl.value;
    if (!search) {
      this.doctorList.next(this.docList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.doctorList.next(
      this.docList.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }
  /**
   *filter teleconsulation list
   *
   * @protected
   * @return {*}
   * @memberof PatientAppointmentComponent
   */
  protected filterteleconsulation() {
    if (!this.Teleconsultations) {
      return;
    }
    let search = this.teleFilterCtrl.value;
    if (!search) {
      this.filteredTelecom.next(this.Teleconsultations.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredTelecom.next(
      this.Teleconsultations.filter(
        (dept) => dept.desc.toLowerCase().indexOf(search) > -1
      )
    );
  }

  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getOrgAppConfigList();
      this.getAppConfigList();
    });
  }
 public getSearchFilter() {
    this.subscriptionList.add(
      this.searchHead
        .getTypeSearch(OPD_API_URL.PATIENT_SEARCH)
        .subscribe((data: any) => {
          this.searchList=this.searchHead.updateSearchHeader(data);
        })
    );
  }
    getOrgAppConfigList() {
      let appConfig: any;
       this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.appBaseService
            .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
            .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res) {
            appConfig = res.keys;
            appConfig.forEach((element) => {
             
              if (element.key == MasterKeys.primaryIdentification){
                if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                  let value = this.primaryIdList.find(i=>i.code == element.valueList[0]?.code)
                  if (!this.primaryValue) {
                     this.showExpirDatePicker = value.isExpireReq && value.isExpireReq==true?true :false;
                    this.primaryValue = value ? value.code : "";
                    this.appointmentForm.controls["IdType"].setValue(this.primaryValue);
                    this.cdr.detectChanges();
                    this.primaryIdentificationOnChange(value, false);
                  }
                }
              }
              if (element.key == MasterKeys.searchByPostCode) {
                if (element.valueList.length > 0) {
                  this.isGetAddress = (element.valueList[0].code == "true") ? true : false;
                }
              }
               if (element.key == MasterKeys.patientNameLtwo) {
                  if (element.valueList.length > 0) {
                    this.ispatientNameLtwo = (element.valueList[0].code == "true") ? true : false;
                  }
                }
                if(element.key == MasterKeys.IS_NEED_TRANSLATOR){
                   if (element.valueList.length > 0) {
                    this.isNeedTranslator = (element.valueList[0].code == "true") ? true : false;
                  }
                }
                if (element.key == MasterKeys.patientNameLtwo) {
                  if (element.valueList.length > 0) {
                    this.ispatientNameLtwo = (element.valueList[0].code == "true") ? true : false;
                  }
                }
              if (element.key == MasterKeys.SHOW_PATIENT_PREFIX) {
                if (element.valueList.length > 0) {
                  this.showPatientPrefix = (element.valueList[0].code == "true") ? true : false;
                }
              }
          });
          } 
        });
    }   
  getAppConfigList() {
    let mrdConfig: any;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource("appConfiguration/findConfigByModule?unitCode=" + this.unitCode +
        "&orgCode=" + this.orgCode + "&moduleName=" + OPD_CONST.patientManagement + "&keyName=")
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        if (res) {
          mrdConfig = res.keys;
          mrdConfig.forEach((element) => {
            if (element.key == MasterKeys.defaultCountry) {
              if (element.valueList.length > 0) {
                this.defaultCountry = element.valueList[0]?.code;
              }
            }
          });
        }
      });
  }
  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        // this.primaryIdFilteredList = data.filter((i) => i.isPrimaryId);
        this.primaryIdList = data;
        this.allPrimaryIdList = data;
      });
  }
  
  
  onChanges() {
    if (this.doctorList.length > 0) {
      this.subscriptionList.add(
        this.deptFilterCtrl.valueChanges.subscribe((value) => {
          this.doctorFilteredList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
      this.subscriptionList.add(
        this.appointmentTypeDFltrCtrl.valueChanges.subscribe((value) => {
          this.doctorList = this.docList.filter((i) =>
            i.desc.toString().toLowerCase().includes(value.toLowerCase())
          );
        })
      );
    }
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonList = this.reasons.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
     this.subscriptionList.add(
      this.primaryIdSearch.valueChanges.subscribe((value) => {
        this.primaryIdList = this.allPrimaryIdList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
     this.appointmentForm.get('Title')?.valueChanges.subscribe(prefixValue => {
      if (prefixValue == undefined || prefixValue == null) {
        this.appointmentForm.controls["Gender"].enable();
        this.appointmentForm.controls["Gender"].setValue(null);
        this.genderValue = null;
      }
    });
  }

  /**
   * To initiate quick search
   * @param event
   */
  searchByMRN(event) {
    let result = { MRN: event.target.value };
    this.setSearch(result,true);
  }
  /**
   *on click checkbox change event
   *
   * @param {*} e
   * @param {*} data
   * @param {*} isReschedue
   * @memberof DialogAddAppointmentPatient
   */
  onCheckboxChange(e: any, data, isReschedue) {
    if (isReschedue) {
      this.checkArray.push(data);
    } else {
      if (e.target.checked) {
        this.checkArray.push(data);
      } else {
        const index: number = this.checkArray.indexOf(data);
        if (index !== -1) {
          this.checkArray.splice(index, 1);
        }
      }
    }
  }
  /**
   *search change event
   *
   * @memberof DialogAddAppointmentPatient
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.appointmentForm.controls["DOB"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
  }
  /**
   *add minutes
   *
   * @param {*} date
   * @param {*} minutes
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  /**
   *select slot event
   *
   * @param {*} slot
   * @memberof DialogAddAppointmentPatient
   */
  slectedSlot(slot) {
    if(this.isOverRightBlockedSlot  && !slot.booked && !slot.past){
      if (slot.selected) {
        slot.selected = false;
      } else {
        this.dilogData.daySlot.forEach((element) => {
          if (element.selected === true) {
            element.selected = false;
          }
        });
        var intialselectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.selected === true
        );
        var selectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.id === slot.id
        );

        if (intialselectedIndex <= 0) {
          slot.selected = true;
        }
        if (
          selectedIndex === intialselectedIndex - 1 ||
          selectedIndex === intialselectedIndex + 1
        ) {
          slot.selected = true;
        }
        var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
        var next = this.dilogData.daySlot[selectedIndex + 1].selected;
        if (prev || next) {
          slot.selected = true;
        }
      }
      this.slotSelectedasGroup();
    
    }else{
    if (slot.past) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsUnavailable"),
        {
          duration: 3000,
        }
      );
    }else if(slot.booked){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsAlreadybooked"),
        {
          duration: 3000,
        });
    } else {
      if (slot.blocked) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.slotIsBlocked"),
          {
            duration: 3000,
          }
        );
      } else {
        if (slot.selected) {
          slot.selected = false;
        } else {
          this.dilogData.daySlot.forEach((element) => {
            if (element.selected === true) {
              element.selected = false;
            }
          });
          var intialselectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.selected === true
          );
          var selectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.id === slot.id
          );

          if (intialselectedIndex <= 0) {
            slot.selected = true;
          }
          if (
            selectedIndex === intialselectedIndex - 1 ||
            selectedIndex === intialselectedIndex + 1
          ) {
            slot.selected = true;
          }
          var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
          var next = this.dilogData.daySlot[selectedIndex + 1].selected;
          if (prev || next) {
            slot.selected = true;
          }
        }
        this.slotSelectedasGroup();
      }
    }
    }
  }
  /**
   *selected as group
   *
   * @memberof DialogAddAppointmentPatient
   */
  slotSelectedasGroup() {
    this.slectedSlotId = [];
    var slected: any = [];
    this.dilogData.daySlot.forEach((element) => {
      if (element.selected) {
        slected.push(element);
        this.slectedSlotId.push(element.id);
      }
    });

    this.selectedSlots = {
      start: slected[0].start,
      end: slected[slected.length - 1].end,
    };
  }

  /**
   *get data Reason master
   *
   * @memberof DialogAddAppointmentPatient
   */
  reasonTypeMaster() {
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : false
     if (isReschedule==true){
      this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"APRS",true)
        .subscribe((res) => {
          res.forEach((element) => {
            this.reasonList.push(element);
            this.reasons.push(element);
          });
        });
     }
    else {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY)
        .subscribe((data: any) => {
          this.reasonList = data;
          this.reasons =data;
        })
      );
  }
}
  /**
   *It is the source of country data.
   *
   * @memberof PatientRegistrationComponent
   */
  getCountryList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_COUNTRY,true)
        .subscribe((data: any) => {
          this.countryPrimaryList = data;
        })
    );
  }
  getCountryCode(value, isCountryId) {
    let id;
    if (isCountryId === true) {
      id = value?.id;
    } else {
      id = this.countryPrimaryList.find((country) => country.code === value)?.id;
    }
    if (id) {
      this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.GET_COUNTRY_CODE + id)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res && res.length > 0) {
            this.mobileCodeValue = res[0].code;
            this.setPatternToMobileNumber(res[0]);
          } else {
            this.mobileCodeValue = "";
          }
        });
    }
  }

  getPrifixList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PREFIX)
        .subscribe((data: any) => {
          this.prefixCodeList = data;
        })
    );
  }

  getspecialReqList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_SPECIALREQLIST,true)
        .subscribe((data: any) => {
          this.specialReqList = data;
        })
    );
  }

  /**
   *get health package
   *
   * @memberof DialogAddAppointmentPatient
   */
  getHealthPackgeList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PACKAGE,true)
        .subscribe((data: any) => {
          this.healthPackageList = data;
        })
    );
  }
  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
          )
          .subscribe((res) => {
            this.statePrimaryList = res;
            if (this.selectedPatient) {
              const stateres = this.statePrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.stateList[0].code
                        : this.selectedPatient.extendedAddress.state.code
                      : this.selectedPatient.extendedAddress.state.code
                    : "")
              );
              this.stateValue = stateres ? stateres.code : "";
              this.getCityPrimaryList(stateres);
            } else if (this.isAddeassByPostCode && this.stateValue) {
              const stateres = this.statePrimaryList.find(
                (i) => i.code == this.stateValue
              );
              if (stateres) {
                this.getCityPrimaryList(stateres);
              }
            }
          })
      );
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof PatientRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
          )
          .subscribe((res) => {
            this.cityPrimaryList = res;
            if (this.selectedPatient) {
              const cityres = this.cityPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.cityList[0].code
                        : this.selectedPatient.extendedAddress.city.code
                      : this.selectedPatient.extendedAddress.city.code
                    : "")
              );
              this.cityValue = cityres ? cityres.code : "";
              this.getSubDistrictPrimaryList(cityres);
              } else if (this.isAddeassByPostCode && this.cityValue) {
              const cityres = this.cityPrimaryList.find(
                (i) => i.code == this.cityValue
              );
              if (cityres) {
                this.getSubDistrictPrimaryList(cityres);
              }
            }
          })
      );
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
          )
          .subscribe((res) => {
            this.subdistPrimaryList = res;

            if (this.selectedPatient) {
              const distres = this.subdistPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.areaList[0].code
                        : this.selectedPatient.extendedAddress.area.code
                      :this.selectedPatient.extendedAddress.area? this.selectedPatient.extendedAddress.area.code:""
                    : "")
              );
              this.districtValue = distres ? distres.code : "";
            } else if (this.isAddeassByPostCode && this.districtValue) {
              const distres = this.subdistPrimaryList.find(
                (i) => i.code == this.districtValue
              );
              this.districtValue = distres ? distres.code : this.districtValue;
            }
          })
      );
    }
  }

  /**
   *identifiation change event
   *
   * @param {*} idTypeCode
   * @memberof DialogAddAppointmentPatient
   */
  // primaryIdentificationOnChange(idTypeCode: any) {
  //   if (idTypeCode.code == OPD_CONST.idTypePassportValue)
  //     this.showExpirDatePicker = true;
  //   else this.showExpirDatePicker = false;
  // }
  // primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove:boolean) {
  //   let appointmentForm = this.appointmentForm.controls;
  //   if(isPrimaryNoRemove){
  //   appointmentForm["IdNumber"].setValue('');
  //   }
  //   if(idTypeCode.code == undefined){
  //     idTypeCode = this.primaryIdList.find(
  //         (s) => s.code == idTypeCode
  //       );
  //   }
  //   if (idTypeCode.value) {
  //     this.primaryIdCode = this.primaryIdList.find(
  //       (s) => s.code == idTypeCode.value
  //     );
  //   }else{
  //       this.primaryIdCode = this.primaryIdList.find(
  //         (s) => s.code == idTypeCode.code
  //       );
  //     }
  //   // if (idTypeCode) {
  //     if (this.primaryIdCode) {
  //       if (this.primaryIdCode.isMyKad == true) {
  //         this.primaryIdRegex = "^[0-9 -]+$";
  //       } else {
  //         this.primaryIdRegex = this.primaryIdCode.validation
  //           ? this.primaryIdCode.validation
  //           : "";
  //       }
  //     }
  //     if (this.primaryIdCode.expiryDuration) {
  //       appointmentForm["idExpiry"].enable();
      
  //             const currentDate = new Date().getFullYear();
  //             const maxExpiryDurationDate = new Date();
  //             maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);
      
  //             this.maxExpiry = maxExpiryDurationDate;
  //           }
  //           else{
  //             this.maxExpiry= new Date(this.year + 20, this.month, this.day);
  //           }
  //          if (this.primaryIdCode.validation) {
  //             this.primaryIdRegex = this.primaryIdCode.validation;
  //             // this.primaryIdRegex = "^[a-zA-Z0-9]{0,9}$";
  //            const match = this.primaryIdRegex.match(/\{(\d+),(\d+)\}/);
  //            this.minIdentificationLength = match ? parseInt(match[1], 10) : null;
  //            this.maxIdentificationLength = match ? parseInt(match[2], 10) : null;
           
  //            this.appointmentForm.controls["IdNumber"].setValidators([
  //              Validators.pattern(this.primaryIdRegex)
  //            ]);
  //          }else{
  //           this.maxIdentificationLength=25;
  //           this.minIdentificationLength=0;
  //           this.primaryIdRegex=OPD_CONST.primaryIdRegix;
  //           this.appointmentForm.controls["IdNumber"].setValidators([
  //             Validators.pattern(this.primaryIdRegex)
  //           ]);
  //          }
  //          this.appointmentForm.controls["IdNumber"].updateValueAndValidity();
  //     if (!this.selectedPatient) {
  //       if (this.primaryIdCode.code.toUpperCase() == OPD_CONST.idTypePassportValue.toUpperCase() || (this.primaryIdCode.isExpireReq && this.primaryIdCode.isExpireReq==true)) {
  //         appointmentForm["idExpiry"].setValue("");
  //         appointmentForm["idExpiry"].enable();
  //         this.showExpirDatePicker = true;

  //         // appointmentForm.issuedCountryPrimary.setValue("");
  //         // appointmentForm.issuedCountryPrimary.enable();
  //       } else {
  //         appointmentForm["idExpiry"].setValue("");
  //         appointmentForm["idExpiry"].disable();

  //         // appointmentForm.issuedCountryPrimary.setValue("");
  //         // appointmentForm.issuedCountryPrimary.disable();
  //         this.showExpirDatePicker = false;
  //       }
  //       this.primaryNumberOnKeyUp(appointmentForm["IdNumber"].value);
  //     }
  //   // }
  // }
 primaryIdentificationOnChange(idTypeCode: any, isPrimaryNoRemove: boolean) {

  const appointmentForm = this.appointmentForm.controls;

  if (isPrimaryNoRemove) {
    appointmentForm["IdNumber"].setValue('');
  }

  if (idTypeCode?.code == undefined) {
    idTypeCode = this.primaryIdList.find(
      s => s.code == idTypeCode
    );
  }

  if (idTypeCode?.value) {
    this.primaryIdCode = this.primaryIdList.find(
      s => s.code == idTypeCode.value
    );
  } else {
    this.primaryIdCode = this.primaryIdList.find(
      s => s.code == idTypeCode?.code
    );
  }

  if (!this.primaryIdCode) {
    return;
  }

  // Regex validation
  if (this.primaryIdCode.isMyKad === true) {
    this.primaryIdRegex = "^[0-9 -]+$";
  } else {
    this.primaryIdRegex = this.primaryIdCode.validation
      ? this.primaryIdCode.validation
      : "";
  }

  // Expiry max date calculation
  if (this.primaryIdCode.expiryDuration) {

    const currentDate = new Date().getFullYear();
    const maxExpiryDurationDate = new Date();

    maxExpiryDurationDate.setFullYear(
      currentDate + this.primaryIdCode.expiryDuration
    );

    this.maxExpiry = maxExpiryDurationDate;

  } else {

    this.maxExpiry = new Date(
      this.year + 20,
      this.month,
      this.day
    );
  }

  // ID number validation
  if (this.primaryIdCode.validation) {

    this.primaryIdRegex = this.primaryIdCode.validation;

    const match = this.primaryIdRegex.match(/\{(\d+),(\d+)\}/);

    this.minIdentificationLength = match
      ? parseInt(match[1], 10)
      : null;

    this.maxIdentificationLength = match
      ? parseInt(match[2], 10)
      : null;

    appointmentForm["IdNumber"].setValidators([Validators.required,
      Validators.pattern(this.primaryIdRegex)
    ]);

  } else {

    this.maxIdentificationLength = 25;
    this.minIdentificationLength = 0;
    this.primaryIdRegex = OPD_CONST.primaryIdRegix;

    appointmentForm["IdNumber"].setValidators([Validators.required,
      Validators.pattern(this.primaryIdRegex)
    ]);
  }

  appointmentForm["IdNumber"].updateValueAndValidity();

  // ==========================================
  // Expiry Date Logic
  // ==========================================

  const expiryDateDisplayed =
    this.primaryIdCode.isExpireDisplayed === true;

  const expiryDateRequired =
    this.primaryIdCode.isExpireReq === true;

  appointmentForm["idExpiry"].setValue("");

  // Case 1 & 2
  if (expiryDateDisplayed) {

    this.showExpirDatePicker = true;
    appointmentForm["idExpiry"].enable();

    if (expiryDateRequired) {

      // Mandatory
      appointmentForm["idExpiry"].setValidators([
        Validators.required
      ]);

    } else {

      // Optional
      appointmentForm["idExpiry"].clearValidators();
    }

  } else {

    // Case 3 & 4
    this.showExpirDatePicker = false;
    appointmentForm["idExpiry"].disable();

    // Optional because field is hidden
    appointmentForm["idExpiry"].clearValidators();
  }

  appointmentForm["idExpiry"].updateValueAndValidity();

  if (!this.selectedPatient) {
    this.primaryNumberOnKeyUp(
      appointmentForm["IdNumber"].value
    );
  }
}
  /**
   *calling method after focus out
   *
   * @param {string} value
   * @memberof DialogAddAppointmentPatient
   */
  idFocusOut(value: string) {
    this.validationOnPrimarynumber(value);
    if (this.patientId) {
      if (this.selectedPatient.id) this.primaryIdentifierListModified = true;
    }

    let primaryIdCode = this.primaryIdList.find(
          (s) => s.code == this.appointmentForm.get("IdType").value
        );
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && value.length < 14)
        this.appointmentForm.controls["IdNumber"].setErrors({
          incorrect: true,
        });
    }
  }
  /**
   *adding validation on primary number
   *
   * @param {string} value
   * @memberof DialogAddAppointmentPatient
   */
  primaryNumberOnKeyUp(value: string) {
  try {
    
    let primaryIdentify = this.primaryIdList.find(
      (s) => s.code == this.appointmentForm.value.IdType
    );

    value = value.replace(/\s|-/g, ""); 

    if (primaryIdentify) {
      
      if (primaryIdentify.isMyKad) {
        
        value = value.replace(/[^\d]/g, "");
        const raw = value;

        
        const npa = value.substr(0, 6);
        const nxx = value.substr(6, 2);
        const last4 = value.substr(8, 4);
        value = npa + "-" + nxx + "-" + last4;
        this.appointmentForm.controls["IdNumber"].setValue(value ? value : "");
        this.primaryIdRegex = "^[0-9 -]+$";

        
        if (raw.length >= 12) {
          const array = Array.from(raw);
          const yearSuffix = parseInt(array[0] + array[1], 10);
          const month = parseInt(array[2] + array[3], 10);
          const day = parseInt(array[4] + array[5], 10);
          const genderDigit = array[11];
          const lastDigit = Number(genderDigit);
            let genderVal = lastDigit % 2 == 0 ? STATICCODESERVICE.GENDER_MASTER_FEMALE : STATICCODESERVICE.GENDER_MASTER_MALE;
            this.genderValue =  genderVal
        
          const currentYear = new Date().getFullYear();
          const currentYearSuffix = currentYear % 100;
          let yr = (yearSuffix > currentYearSuffix) ? 1900 + yearSuffix : 2000 + yearSuffix;

          let birthDate = new Date(yr, month - 1, day);
          const today = new Date();

          if (birthDate > today && !this.isSameDate(birthDate, today)) {
            yr -= 100;
            birthDate = new Date(yr, month - 1, day);
          }

          
          if (this.isValidDate(yr, month, day)) {
            this.appointmentForm.patchValue({
              DOB: birthDate,
              realdob: true
            });
          } else {
            this.snackBar.open(
              this.langService.get("CommonAppoinment.InvalidNRIC"),
              this.langService.get("CommonAppoinment.validation"),
              { duration: 1000 }
            );
            this.appointmentForm.patchValue({
              DOB: null,
              realdob: false,
              Birthplace: null
            });
            this.genderValue = "";
            this.appointmentForm.controls["IdNumber"].setValue("");
          }
        }

      } 
      
      else {
        this.primaryIdRegex = "[A-Za-z0-9]*";
        this.appointmentForm.controls["IdNumber"].setValue(value ? value : "");
      }
    }
  } catch (ex) {}
}
isSameDate(date1, date2) {
    return date1.getFullYear() == date2.getFullYear() &&
           date1.getMonth() == date2.getMonth() &&
           date1.getDate() == date2.getDate();
  }
  isValidDate(year, month, day) {
    if (month < 1 || month > 12) {
      return false;
    }
  
    let daysInMonth;
    if (month == 2) {
      daysInMonth = this.isLeapYear(year) ? 29 : 28;
    } else if ([4, 6, 9, 11].includes(month)) {
      daysInMonth = 30;
    } else {
      daysInMonth = 31;
    }
    return day > 0 && day <= daysInMonth;
  }
  isLeapYear(year) {
    return (year % 4 == 0 && year % 100 != 0) || (year % 400 == 0);
  }
  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
   validationOnPrimarynumber(value: string) {
    if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.appointmentForm.controls["IdType"].value;
      if (primaryIdCode) {
        this.generalApiServiceapt
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if(res!=null){
             this.appointmentForm.controls["IdNumber"].setValue("");
            }
           });
      }
    }
  }
  /**
   *
   *
   * @param {*} companyValue
   * @memberof DialogAddAppointmentPatient
   */
  pakageChecked(packageValue) {
    this.checkedPackageList = [];
    for (let i = 0; i < this.healthPackageList.length; i++) {
      if (packageValue.indexOf(this.healthPackageList[i]) != -1)
        this.checkedPackageList.push(this.healthPackageList[i]);
    }
  }
  /**
   *binding gender value
   *
   * @param {*} prefixvalue
   * @memberof DialogAddAppointmentPatient
   */
  // getGender(prefixvalue) {
  //   let formappoinment = this.appointmentForm.controls;
  //   let res =
  //     prefixvalue && prefixvalue.genderMaster
  //       ? prefixvalue.genderMaster.code
  //       : "";
  //   if (res) {
  //     this.genderValue = res;
  //     formappoinment.Gender.disable();
  //   } else {
  //     this.genderValue = "";
  //     formappoinment.Gender.enable();
  //   }
  // }

  getGender(prefixvalue) {
    let formRegistration = this.appointmentForm.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["Gender"].disable();
    } else {
      this.genderValue = this.defaultGender ? this.defaultGender :"" ;
      formRegistration["Gender"].enable();
    }
  }
  /**
   *calculate DOB method
   *
   * @param {string} age
   * @param {string} month
   * @memberof DialogAddAppointmentPatient
   */
  // calculateDob(age: string, month: string) {
  //   let agecalc;
  //   let monthcalc;

  //   if (age != "0") {
  //     agecalc = age.split("Y", 1);
  //   } else {
  //     agecalc = 0;
  //   }
  //   if (month != "0") {
  //     monthcalc = month.split("M", 1);
  //   } else {
  //     monthcalc = 0;
  //   }
  //   var todayDate = new Date();
  //   var ageyear = todayDate.getFullYear() - Number(agecalc);
  //   var agemonth = todayDate.getMonth() - Number(monthcalc);
  //   var ageday = todayDate.getDate() - 0;
  //   this.appointmentForm.controls.DOB.setValue(
  //     new Date(ageyear, agemonth, ageday)
  //   );
  // }
  calculateDob(age: string, month: string, day: string | number) {
    let formAppointment = this.appointmentForm.controls;

    let agecalc;
    let monthcalc;
    let daycalc;


    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    if (day != "0") {
    daycalc = day;
  } else {
    daycalc = 0;
  }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - Number(daycalc);
    this.appointmentForm.controls["DOB"].setValue(
      new Date(ageyear, agemonth, ageday)
    );
    formAppointment["DOB"].setValue(new Date(ageyear, agemonth, ageday));

  }
  /**
   *clear form
   *
   * @memberof DialogAddAppointmentPatient
   */
  clearForm() {
    this.patientType =OPD_CONST.aptref.new;
    this.patientData = false;
    this.primaryValue = null;
    this.prefixValue = null;
    this.genderValue = null;
    this.mobileCodeValue = null;
    this.countryValue = null;
    this.stateValue = null;
    this.cityValue = null;
    this.districtValue = null;
    this.healthPackage = [];
    this.specialReq = [];
    this.imageUser = null;
    this.appointmentForm.reset();
    this.patientInfoDisplay = null;
    this.resultFound = false;
    this.selectedPatient=null;
    this.patientTypeCat= OPD_CONST.aptref.new;
    this.appointmentForm.enable();
    this.dilogData.waitingPatient=null;
  }
  /**
   *On save click calling method
   *
   * @param {*} form
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
   onSubmit(form) {
    for (var i in this.appointmentForm.controls) {
      this.appointmentForm.controls[i].markAsTouched();
    }
    if (this.appointmentForm.valid || this.appointmentForm.disabled) {
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : ""
     if (isReschedule==="1" || isReschedule==="2"){
      if(!this.reason){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.selectreason"),
        {
          duration: 3000,
        }
      );
      return;
      }
     }
      if (this.isHsc && this.checkedPackageList.length == 0) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
          {
            duration: 3000,
          }
        );
        return;
      } else if (this.patientType === "registered" && !this.selectedPatient) {
        this.snackBar.open("Please select Patient", "Validation", { duration: 2000 });
        return;
      } else {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "20pc",
          data: { displayText: "doyouwanttoproceed" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result.confirm == "yes") {
              if(this.dilogData.waitingPatient){
                this.waitingPatientAppointment();
              }else{
              this.saveAppointment(form);
              }
            }
          })
        );
      }
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
        {
          duration: 3000,
        }
      );
      return;
    }
  }
  waitingPatientAppointment(){
     if(this.dilogData.waitingPatient){
      this.ngxService.start();

      let Payload={
        id:this.dilogData.waitingPatient.id,
        startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
        endTimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
        slots: this.slectedSlotId
    }
    this.generalApiServiceapt
    .patchTypeApi(
      OPD_API_URL.OPD_SERVICE,
      OPD_API_URL.CONFIRM_WAITING_PATIENT,
      Payload
    )
    .subscribe((response: any) => {
      this.ngxService.stop();
      if(response){
        this.snackBar.open("Patient Confirm Successfully","Success",{duration:2000});
        this.dialogRef.close();
      
        this.appointmentForm.reset();
        this.reason = "";
        if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
          localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
      }
    })
    }
  }
  /**
   *save appointment method
   *
   * @param {*} form
   * @memberof DialogAddAppointmentPatient
   */
  saveAppointment(form) {
    if (
      this.patientType === "registered" &&
      this.selectedAppointmentDate &&
      (this.selectedPatient?.mrn || this.mrn)
    ) {

      let mrn = this.selectedPatient?.mrn || this.mrn;
      let appointmentDate = this.selectedAppointmentDate;
      const reqPayload = `mrn=${mrn}&appointmentDate=${appointmentDate}`;

      this.generalApiServiceapt.getTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_APPOINTMENT_CONFLICT + reqPayload
      ).subscribe((res: any) => {

        if (res?.hasConflict) {

          const dialogRef = this.dialog.open(SameDayAppointmentDialogComponent, {
            width: '550px',
            data: res
          });

          dialogRef.afterClosed().subscribe(result => {

            if (result === 'continue') {
              this.proceedSave(form);
            }
          });


        } else {
          this.proceedSave(form);
        }

      });

    } else {
      this.proceedSave(form);
    }
  }
  proceedSave(form) {
let specialList=[];
   if(this.checkArray.length>0)
  {
   this.checkArray.forEach(element => {
    let listItem = {
      system: "EN",
      code: element.code,
      display: element.desc
  }
     specialList.push(listItem)
   });
   }
    this.saveAction = true;
    var patCat: any = {};
    var patient: any = {};
    if (this.patientTypeCat == OPD_CONST.aptpatientType.desc) {
      patCat = {
        code: OPD_CONST.aptpatientType.code,
        display: OPD_CONST.aptpatientType.desc,
        system: OPD_CONST.aptpatientType.system,
      };
      patient = {
        code: this.selectedPatient.mrn,
        display: this.selectedPatient.id,
        system: OPD_CONST.appoinmentRef.extendedPatient,
      };
    } else {
      patCat = {
        code: OPD_CONST.aptpatientTypeTemp.code,
        display: OPD_CONST.aptpatientTypeTemp.desc,
        system: OPD_CONST.aptpatientTypeTemp.system,
      };
      patient = {
        code: "",
        display: "",
        system: "",
      };
    }
    var obj = {
      code: "",
      display: "",
      system: "",
    };
    let aptTypeValue = this.dilogData.appointmentTypeList.find(
      (s) => s.code == this.dilogData.appointmentType
    );
    let conTypeValue = this.dilogData.consultationtypeList.find(
      (s) => s.code == this.dilogData.consultationtype
    );
    let deptValue = this.dilogData.departmentList.find(
      (s) => s.code == this.dilogData.department
    );
    let reasonValue = this.reasonList.find((s) => s.code == this.reason);
    var serviceCategory = {
      code: aptTypeValue.code,
      display: aptTypeValue.desc,
      system: OPD_CONST.aptpatientType.system,
    };
    var reason = {
      code: reasonValue ? reasonValue.code : "",
      display: reasonValue ? reasonValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    var consultationType = {
      code: conTypeValue ? conTypeValue.code : "",
      display: conTypeValue ? conTypeValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let service = this.getObjByCode(
      this.dilogData.appointmentTypeList,
      this.dilogData.appointmentType
    );
    let entitydesc = this.getObjByCode(
      this.dilogData.doctorList,
      this.dilogData.doctor.code
    );
    let countryCode = {
      code: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.code
        : "",
      display: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.desc
        : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let packageList = [];
    if (this.checkedPackageList.length > 0) {
      this.checkedPackageList.forEach((element) => {
        let res = this.langService.createObjectList(element);
        packageList.push(res[0], res[1]);
      });
    }

    let idType = this.primaryIdList.find(
          (s) => s.code == form.controls.IdType.value
        );
    var formvalue=form.getRawValue();      
    this.visitTypeCtrl = this.appointmentTypeList.find(
      (s) => s.code == this.visitType?.value
    ); 
    this.teleTypeCtrl = this.Teleconsultations.find(
      (s) => s.code == this.teleConsultCtrl?.value
    );
    this.deptTypeCtrl = this.departmentList.find(
      (s) => s.code == this.deptCtrl?.value
    );
    let payload = {
      idTypeList: this.langService.createObjectList(idType),
      idNumber: formvalue.IdNumber,
      idExpiry: formvalue.idExpiry?.$d ? formvalue.idExpiry.$d : formvalue.idExpiry? formvalue.idExpiry : "",
      titleList: this.langService.createObjectList(form.controls.Title.value),
      patientName: formvalue.FullName,
      photo: {
        contentType: "image/jpeg",
        url:  this.imageUser,
      },
      //first middle last name in uppercase 
      firstName:formvalue.firstName 
      ? formvalue.firstName.toUpperCase()
      : (formvalue.mfirstName?.length > 0 ? formvalue.mfirstName.toUpperCase() : ""),
      middleName:formvalue.middleName 
      ? formvalue.middleName.toUpperCase()
      : (formvalue.mmiddleName?.length > 0 ? formvalue.mmiddleName.toUpperCase() : ""),
      lastName:formvalue.lastName 
      ? formvalue.lastName.toUpperCase()
      : (formvalue.mlastName?.length > 0 ? formvalue.mlastName.toUpperCase() : ""),

      // first middle last name in thai
      mfirstName:formvalue.mfirstName?formvalue.mfirstName:"",
      mmiddleName:formvalue.mmiddleName?formvalue.mmiddleName:"",
      mlastName:formvalue.mlastName?formvalue.mlastName:"",
      
      genderList: this.langService.createObjectList(form.controls.Gender.value),
      caseTypeList: null,
      dob: this.datepipe.transform(formvalue.DOB, 'yyyy-MM-dd'),
      email: formvalue.Email,
      countryCode: countryCode,
      mobileNo: formvalue.HandPhoneNumber,
      officeNo: formvalue.OffciePhoneNumber,
      homeNo: formvalue.HomePhoneNumber,
      patientType: patCat,
      patient: patient,
      referalEntity: null,
      companyList: null,
      subSpecialityList: null,
      remarks: formvalue.Remarks ? formvalue.Remarks : null,
      specialityList: this.langService.createObjectList(deptValue),
      doctorList: this.langService.createObjectList(entitydesc),
      startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
      endtimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
      serviceList: this.langService.createObjectList(service),
      serviceCategory: serviceCategory,
      slots: this.slectedSlotId,
      appointmentType: serviceCategory,
      consultationType: consultationType,
      isReal: formvalue.realdob,
      extendedAddress: {
        countryList: this.langService.createObjectList(
          form.controls.countryPrimary.value
        ),
        cityList: this.langService.createObjectList(
          form.controls.cityPrimary.value
        ),
        stateList: this.langService.createObjectList(
          form.controls.statePrimary.value
        ),
        areaList: this.langService.createObjectList(
          form.controls.subDistrictPrimary.value
        ),
        postCode: formvalue.pincodePrimary ? formvalue.pincodePrimary : null,
        addressLine: formvalue.addressPrimary
          ? formvalue.addressPrimary
          : null,
      },
      specialRequirements: this.checkArray.length>0?specialList:[],
      trn: this.dilogData.reScheduleData
        ? this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? this.dilogData.reScheduleData.MRN
          : ""
        : "",
      existingAppointmentId: this.dilogData.reScheduleData
        ? this.dilogData.reScheduleData.id
        : "",
      rescheduleRemarks: this.dilogData.reScheduleData ? this.reschRemarks : "",
      reason: reason ? reason : obj,
      packageList: packageList,
      unitName:this.unitName?this.unitName:"",
      orgName:this.orgName?this.orgName:"",
      appointmentVisitTypeList: this.langService.createObjectList(this.visitTypeCtrl),
      appointmentConsultationTypeList: this.langService.createObjectList(this.teleTypeCtrl),
      appointmentSpecialtyList: this.langService.createObjectList(this.deptTypeCtrl),
      patientCategoryList: this.langService.createObjectList(form.controls.patientCategory?.value),
      priorityList: this.langService.createObjectList(form.controls.priority?.value),
      specialInstruction: formvalue.specialInstruction ? formvalue.specialInstruction : null,
      needTranslator: formvalue.needTranslator ?? false,
      translatorLanguage: formvalue.translatorLanguage ? formvalue.translatorLanguage : null,
    };
    this.generalApiServiceapt
      .postTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.OPD_APPOINTMENT_SAVE,
        payload
      )
      .subscribe((response: any) => {
        this.saveAction = false;
    
      let isReschedue=this.dilogData.reScheduleData?this.dilogData.reScheduleData.isReschedule:false;
        let message=isReschedue ? this.langService.get("CommonAppoinment.successfullyrescheduled"):this.langService.get("CommonAppoinment.successfullycreated")
        this.snackBar.open(
          this.langService.get("CommonAppoinment.success"),

          this.langService.get(
            message
          ),
          {
            duration: 5000,
          }
        );
        this.dialogRef.close();
        let reqPayload = {
          transactionId: response.appointment ? response.appointment.id : "",
          type: OPD_REPORT_TYPE.pdf,
          reportName: OPD_REPORT_NAME.appointment_Slip,
          isReports: false,
        };
        localStorage.setItem(
          OPD_CONST.reportPayload,
          JSON.stringify(reqPayload)
        );
        window.open(opdNavigation.REPORT_NAVIGATE);
        this.appointmentForm.reset();
        this.reason = "";
        if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
          localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
        if (localStorage.getItem(OPD_CONST.aptref.rescheduleApp)) {
          localStorage.removeItem(OPD_CONST.aptref.rescheduleApp);
         }
        if (localStorage.getItem(OPD_CONST.appoinmentRef.appointmentEncounter)) {
         localStorage.removeItem(OPD_CONST.appoinmentRef.appointmentEncounter);
        }
        this.router.navigate([OPD_API_URL.OPD_APPOINTMENT_LIST]);
      });
  }
  
  /**
   *getobj method
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof DialogAddAppointmentPatient
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }
  /**
   *selectd image
   *
   * @memberof DialogAddAppointmentPatient
   */
  selectFile() {
    document.getElementById(OPD_CONST.appoinmentRef.fileAttachment).click();
  }

  /**
   *select handle file
   *
   * @param {*} evt
   * @memberof DialogAddAppointmentPatient
   */
  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }
  /**
   *load event for image
   *
   * @param {*} readerEvt
   * @memberof DialogAddAppointmentPatient
   */
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.imageUser = OPD_CONST.appoinmentRef.imageData + this.base64textString;
  }

  /**
   *Destroy method
   *
   * @memberof DialogAddAppointmentPatient
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum / 1000;
  }
  /**
   *selection change value
   *
   * @param {*} name
   * @param {*} value
   * @memberof DialogAddAppointmentPatient
   */
  selectOnChange(name, value) {
    this.dropdownValues[name] = value.id;
  }
  /**
   *Select on click
   *
   * @param {*} control
   * @param {*} parent
   * @param {*} child
   * @memberof DialogAddAppointmentPatient
   */
  selectOnClick(control, parent, child) {
    let _this = this;
    try {
      let value = "";
      let hasParam = false;
      if (
        control.url &&
        control.url.includes("{") &&
        control.url.includes("{") &&
        !control.url.includes("{UnitMaster}")
      ) {
        let param = control.url.substring(
          control.url.lastIndexOf("{") + 1,
          control.url.lastIndexOf("}")
        );
        if (this.dropdownValues[param]) {
          control.url = control.url.replace(
            /\{.*?\}/,
            "'" + this.dropdownValues[param].trim() + "'"
          );
        } else {
          control.url = control.url.replace(/\{.*?\}/, "''");
        }
        hasParam = true;
      }
      if (
        !this.searchList[parent].controls[child].options ||
        this.searchList[parent].controls[child].options.length == 0 ||
        hasParam
      ) {
        this.baseservice.setResourceURL("/");
        this.subscriptionList.add(
          this.baseservice.getResource(control.url).subscribe((res) => {
            this.searchList[parent].controls[child].options = res;
            setTimeout(() => {
              document.getElementById(control.name).click();
            }, 500);
          })
        );
      }
    } catch (ex) {}
  }
  /**
   *Clear Search
   *
   * @memberof DialogAddAppointmentPatient
   */
  clearSearch() {
    if(this.searchList.length > 0){
    this.searchList.forEach((search) => {
      search.controls.forEach((control) => {
        this[control.name] = "";
        control.searchValue = "";
        control.options=control.masterList;
      });
    });
    }
  }

    dropdownOnSearch(control: SearchControl, event) {
      if (!control.masterList || control.masterList.length == 0)
        control.masterList = control.options;
      control.searchValue = event.srcElement.value;
      if (control.masterList.length > 0) {
        control.options = control.masterList.filter((i) =>
          i.desc.toString().toLowerCase().includes(control.searchValue.toLowerCase())
        );
      }
    }
  /**
   *set Search existing Patient data
   *
   * @param {*} data
   * @memberof DialogAddAppointmentPatient
   */
  setSearch(data,isResetOffset?) {
    if (isResetOffset) {
      this.offset = 0;
      this.dataSource = new MatTableDataSource<any>([]);
    }

    let keysArray = Object.keys(data);
    let hasValue = false;
    
    for (let i = 0; i < keysArray.length; i++) {
      let value = data[keysArray[i]];
      if (  value !== "" && value !== null && value !== undefined 
      ) {
        hasValue = true;
        break; 
      }
    }
    
    if (hasValue) {
      const birthDate = data.dob
      ?  moment(data.dob, "DD/MM/YYYY hh:mm:ss aa").format("YYYY-MM-DD")
      : "";
      this.partientSearch = {
        MRN: data.MRN ? data.MRN : "",
      PatientName: data.PatientName ? data.PatientName : "",
      identificationType: data.identificationType
        ? data.identificationType
        : "",
      identificationNumber: data.identificationNumber
        ? data.identificationNumber
        : "",
      MobileNo: data.MobileNo ? data.MobileNo : "",
      birthDate: birthDate,
      patientCategory: data.patientCategory ? data.patientCategory.code : "",
      offset: this.offset,
      limit: this.limit,
    };
    this.clearSearch();
    var payload = this.appoinmentServiceApt.getSearchPatient(this.partientSearch);
    this.subscriptionList.add(
      this.generalApiServiceapt
        .getTypeApi(OPD_API_URL.OPD_SERVICE, payload)
        .subscribe((res) => {
          if(res.length>0){
          this.patientList = res;
          this.patientData = true;
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          const existingData = this.dataSource?.data || [];
          const updatedData =isResetOffset? [...res]: [...existingData, ...res];
          this.dataSource = new MatTableDataSource<any>(updatedData);
          this.loadingData = false;
          if (this.dilogData.reScheduleData || this.dilogData.waitingPatient)
            this.radioClicked1(this.patientList[0]);
        }
        })
    );
    } else {
       this.snackBar.open(
        this.langService.get("CommonAppoinment.onesearchparameter"),
        this.langService.get("CommonAppoinment.warning"),
         {
        duration: 3000,
      });
    }
  }
  /**
   *set temp patient data
   *
   * @param {*} data
   * @memberof DialogAddAppointmentPatient
   */
  setTempPatient(data) {
    var partientSearch = {
      mrn: data.MRN ? data.MRN : "",
    };
    this.clearSearch();
    this.baseservice.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.baseservice
        .getResource(OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + partientSearch.mrn)
        .subscribe((res) => {
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          this.dataSource = new MatTableDataSource<any>(res);
          if (this.dilogData.reScheduleData) this.resultFound = false;
          this.selectedPatient = res;
          (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            (this.primaryValue = res.primaryIdentificationType
              ? res.primaryIdentificationType[0].code
              : ""),
            (this.prefixValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.mobileCodeValue = res.countryCode
              ? res.countryCode.code
              : ""),
            (this.countryValue = res
              ? res.extendedAddress
                ? res.extendedAddress.countryList
                  ? res.extendedAddress.countryList[0].code
                  : null
                : null
              : null);
          let remarks = this.dilogData.reScheduleData
            ? this.dilogData.reScheduleData.remarks
            : "";
          let specialInstruction = this.dilogData.reScheduleData
            ? this.dilogData.reScheduleData.specialInstruction
            : "";
          this.appointmentForm.patchValue({
             IdType: res.primaryIdentificationType
               ? res.primaryIdentificationType[0].code
               : "",             
            IdNumber: res.idNumber ? res.idNumber : "",
            FullName: res.patientName,
            firstName: res.firstName ? res.firstName : "",
            middleName: res.middleName ? res.middleName : "",
            lastName: res.lastName ? res.lastName : "",
            mfirstName: res.mfirstName ? res.mfirstName : "",
            mmiddleName: res.mmiddleName ? res.mmiddleName : "",
            mlastName: res.mlastName ? res.mlastName : "",
            Email: res.email ? res.email : "",
            HandPhoneNumber: res.mobileNo ? res.mobileNo : "",
            OffciePhoneNumber: res.officeNo ? res.officeNo : "",
            HomePhoneNumber: res.homeNo ? res.homeNo : "",
            DOB: res.dob ? new Date(res.dob) : "",
            idExpiry: res.idExpiry ? new Date(res.idExpiry) : "",
            Remarks: remarks,
            specialInstruction: specialInstruction,
            addressPrimary: res.extendedAddress
              ? res.extendedAddress.addressLine
              : "",
            pincodePrimary: res.extendedAddress
              ? res.extendedAddress.postCode
              : "",
            needTranslator: res.needTranslator,
            translatorLanguage: res.translatorLanguage
          });
          this.getStatePrimaryList(
            res.extendedAddress && res.extendedAddress.countryList
              ? res.extendedAddress.countryList[0].code
              : "",
            true
          );
        })
    );
  }
  /**
   *mobile format
   *
   * @memberof DialogAddAppointmentPatient
   */
  mobileNumberFormat() {
    let trimmedNumber = this.mobile.replace(/-/g, "");
    let A = trimmedNumber.substr(0, 3);
    let B = trimmedNumber.substr(3, 11);
    let str1 = trimmedNumber.length >= 4 ? "-" + B : B;
    this.mobile = A + str1;
  }
  /**
   *days in month
   *
   * @param {*} date2_UTC
   * @return {*}
   * @memberof DialogAddAppointmentPatient
   */
  DaysInMonth(date2_UTC) {
    var monthStart: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth(),
      1
    );
    var monthEnd: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth() + 1,
      1
    );
    var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
    return monthLength;
  }
  /**
   *load slots
   *
   * @memberof DialogAddAppointmentPatient
   */
  loadSlots() {
    const len = this.timeSlotsArray.length;
    for (let i = 0; i < len; i++) {
      const obj = {
        start: "",
        end: "",
        startValue: "",
        endValue: "",
        status: "",
        slotId: "",
      };
      if (
        this.timeSlotsArray[i + 1] &&
        this.timeSlotsArray[i].end == this.timeSlotsArray[i + 1].start
      ) {
        obj.status = this.timeSlotsArray[i].status;
        obj.start = this.timeSlotsArray[i].start;
        obj.end = this.timeSlotsArray[i].end;
        obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
        obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
        obj.slotId = this.timeSlotsArray[i].id;
      } else {
        if (i + 1 == len) {
          obj.status = this.timeSlotsArray[i].status;
          obj.start = this.timeSlotsArray[i].start;
          obj.end = this.timeSlotsArray[i].end;
          obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
          obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
          obj.slotId = this.timeSlotsArray[i].id;
        } else {
          if (this.breakTimes.start != undefined) {
            obj.status = "break";

            obj.start = this.breakTimes.start;
            obj.end = this.breakTimes.end;
            obj.startValue = this.breakTimes.start;
            obj.endValue = this.breakTimes.end;
            obj.slotId = "";
          }
        }
      }
      this.timeSlotList.push(obj);
    }
  }
  /**
   *radio clicked
   *
   * @param {*} i
   * @memberof DialogAddAppointmentPatient
   */
  radioClicked1(i) {
    this.appointmentForm.disable();
    this.appointmentForm.get('visitType')?.enable();
    this.appointmentForm.get('Remarks')?.enable();
    this.appointmentForm.get('priority')?.enable();
    this.appointmentForm.get('specialInstruction')?.enable();
    this.appointmentForm.get('needTranslator')?.enable();
    this.appointmentForm.get('translatorLanguage')?.enable();
    this.visitType.disable();
    this.teleConsultCtrl.disable();
    this.deptCtrl.disable();
    if(i.isBlocked==false) {
      this.patientData=false;
      this.isVip=i.vip;
      this.isNoteVisible = i.patientNotes ? i.patientNotes.note :"";
    this.isDisabled = true;
    this.resultFound = false;
    this.selectedPatient = i;
    (this.genderValue = i.gender ? i.gender.code : ""),
      (this.primaryValue = i.primaryIdentifier ? i.primaryIdentifier.code : ""),
      (this.prefixValue = i.title ? i.title.code : ""),
      (this.mobileCodeValue = i.mobileNumber ? i.mobileNumber.countryCode : i.countryCode?i.countryCode:"");
    this.countryValue = i
      ? i.extendedAddress
        ? i.extendedAddress.country.code
        : null
      : null;
    let remarks = this.dilogData.reScheduleData
      ? this.dilogData.reScheduleData.remarks
      : this.dilogData?.waitingPatient?this.dilogData.waitingPatient.remarks:"";
      this.defaultGender = i.gender ? i.gender.code : ""
      if (i.title) {
        const prefix = this.prefixCodeList.find(item => item.code === i.title.code);
        if (prefix) {
          this.getGender(prefix);
        }
      }
      let mrn=i.mrn?i.mrn:i.identifier[0].value
      let name = Array.isArray(i.name) && i.name.length > 0 ? i.name[0].text || i.name[0] : i.name;
    let gender = i.gender.code.toUpperCase();
    let specialInstruction = this.dilogData.reScheduleData
      ? this.dilogData.reScheduleData.specialInstruction
      : null;
    this.showExpirDatePicker = i.primaryIdentifier && i.primaryIdentifier.expiryDate?true :false;
    this.patientCategoryValue=i.patientCategory ? i.patientCategory.code : "";
    let displayTitle =i.title ? i.title?.display : ""
    let patientNameLangBase = i.patientNameLangBase ? i.patientNameLangBase : name;
    this.appointmentForm.patchValue({
      IdNumber: i.primaryIdentifier ? i.primaryIdentifier.value : "",
      FullName: name,
      firstName: i.firstName ?? '',
      middleName: i.middleName ?? '',
      lastName: i.lastName ?? '',
      mfirstName: i.mfirstName ?? '',
      mmiddleName: i.mmiddleName ?? '',
      mlastName: i.mlastName ?? '',
      Email: i.telecom ? i.telecom[0].value : "",
      HandPhoneNumber: i.mobileNumber ? i.mobileNumber.mobileNumber :  i.telecom ? i.telecom[1].value:"",
      OffciePhoneNumber: i.telecom ? i.telecom[2].value : "",
      HomePhoneNumber: i.telecom ? i.telecom[3].value : "",
      DOB: new Date(i.birthDate),
      IdType:  i.primaryIdentifier ? i.primaryIdentifier.code : "",
      idExpiry: i.primaryIdentifier
        ? i.primaryIdentifier.expiryDate
          ? new Date(i.primaryIdentifier.expiryDate)
          : ""
        : "",
      Remarks: remarks,
      specialInstruction: specialInstruction,
      addressPrimary: i.extendedAddress ? i.extendedAddress.addressLine : "",
      pincodePrimary: i.extendedAddress ? i.extendedAddress.postCode : "",
      needTranslator: i.needTranslator,
      translatorLanguage: i.translatorLanguage,
      displayTitle: displayTitle
    });
    this.getStatePrimaryList(
      i.extendedAddress && i.extendedAddress.country
        ? i.extendedAddress.country.code
        : "",
      true
    );
    var dobFormatted = "";
    var patientAge = "";
    if (i.birthDate) {
      dobFormatted = this.datepipe.transform(i.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      mrn +
      " / " + (this.showPatientPrefix ? displayTitle + " " : "")  +
      patientNameLangBase +
      " / " +
      (gender ? gender : "UNKNOWN") +
      " / " +
      (i.birthDate ? dobFormatted : " ") +
      " (" +
      (this.patientAge ? this.patientAge.years : "") +
      ")";
    Image: i.photo ? i.photo[0].url : "";
  }else{
    this.snackBar.open(
      this.langService.get("CommonAppoinment.alreadyBlocked"),
      this.langService.get("CommonAppoinment.warning"),
      {
      duration: 3000,
    });
  }
  }
  /**
   *set mobiel format values
   *
   * @param {string} value
   * @param {string} name
   * @memberof DialogAddAppointmentPatient
   */
  mobileFormat(value: string, name: string) {
    var r = /(\D+)/g,
      npa = "",
      last4 = "";
    value = value.replace(r, "");
    npa = value.substr(0, 3);
    last4 = value.substr(3, 10);
    value = npa + "-" + last4;
    if (value.replace("-", "").trim() == "") value = "";
    if (name == OPD_CONST.aptref.mobile) {
      this.appointmentForm.controls["HandPhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.home) {
      this.appointmentForm.controls["HomePhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.work) {
      this.appointmentForm.controls["OffciePhoneNumber"].setValue(value);
    }
  }
  /**
   *patient type change on event
   *
   * @param {*} $event
   * @memberof DialogAddAppointmentPatient
   */
  public patientTypeChange($event) {
    this.appointmentForm.reset();
    this.patientTypeCat = $event.value;
    this.patientType = $event.value;
    this.isPatientNew = $event.value == "new";
    this.disableForm = this.isPatientNew;    
    this.genderValue = null;
    if(this.patientType=="registered"){
        this.appointmentForm.disable();
      this.visitType.disable();
      this.teleConsultCtrl.disable();
      this.deptCtrl.disable();
        this.appointmentForm.get('visitType')?.enable();
        this.appointmentForm.get('Remarks')?.enable();
        this.appointmentForm.get('priority')?.enable();
        this.appointmentForm.get('specialInstruction')?.enable();
        this.appointmentForm.get('needTranslator')?.enable();
        this.appointmentForm.get('translatorLanguage')?.enable();
        this.patientData = false;
    }else{
        this.appointmentForm.enable();
      this.visitType.enable();
      this.teleConsultCtrl.enable();
      this.deptCtrl.enable();
        this.patientInfoDisplay = null;
        this.dataSource = new MatTableDataSource<any>();
        this.resultFound=false;
        this.patientData = false;
    }
  }
  /**
   *clsose mehthod
   *
   * @memberof DialogAddAppointmentPatient
   */
  closeModal() {
    this.dialogRef.close();
  }

  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    var dobFormatted = "";
    var patientAge = "";
    if (patient.birthDate) {
      dobFormatted = this.datepipe.transform(patient.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.birthDate ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";

    this.radioClicked1(this.data);
  }
  setPatternToMobileNumber(event){
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.appointmentForm.controls["HomePhoneNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      } 
    } else {
      this.appointmentForm.controls["HomePhoneNumber"].markAsTouched();
    }
    this.appointmentForm.controls["HomePhoneNumber"].updateValueAndValidity();
  }
  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    const buffer = 500;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit && !this.loadingData) {
      this.loadingData = true; 
      this.offset += 1;
      this.setSearch(this.partientSearch,false);
    }
  }
  getWaitingpatient(){
    const form = this.appointmentForm.controls;
    const patientData = this.dilogData.waitingPatient?.patient || this.dilogData.waitingPatient?.temporaryPatient || null;

    if(this.dilogData.waitingPatient.specificDateList){
      this.datePreferanceDiaplay = this.convertTimestampsToDates(this.dilogData.waitingPatient.specificDateList);
    }
    if(this.dilogData.waitingPatient.expectedEndDateTime && this.dilogData.waitingPatient.expectedStartDateTime){
      this.datePreferanceDiaplay =`${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedStartDateTime  * 1000), 'dd/MM/yyyy') } To
      ${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedEndDateTime  * 1000), 'dd/MM/yyyy') }`
    }
     
  this.selectedPatient = patientData;
    if (this.dilogData.waitingPatient?.patientType?.code === 'TEMP') {
      const primaryIdType = patientData.primaryIdentificationType?.[0];
      this.primaryValue = primaryIdType?.code || "";
      // this.primaryIdentificationOnChange(primaryIdType,false);
      const selectedMaster = this.primaryIdList.find(
        x => x.code === primaryIdType?.code
      );
      if (selectedMaster) {
        this.primaryIdentificationOnChange(selectedMaster, false);
      }
      this.prefixValue = patientData.title?.code || '';
      this.genderValue = patientData.gender?.code || '';
      this.mobileCodeValue = patientData.countryCode?.code || '';
      
      const country = patientData.extendedAddress?.country;
      this.countryValue = country?.code || '';
      if (country?.code) {
        this.getStatePrimaryList(country.code, true);
      }
      
      this.stateValue = patientData.extendedAddress?.state?.code || '';
      
      form["IdNumber"].patchValue(patientData.idNumber || "");
      form["FullName"].patchValue(patientData.patientName || "");
      form["Email"].patchValue(patientData.email || "");
      form["HandPhoneNumber"].patchValue(patientData.mobileNumber || "");
      form["OffciePhoneNumber"].patchValue(patientData.officeNo || "");
      form["HomePhoneNumber"].patchValue(patientData.homeNo || "");
      form["DOB"].patchValue(patientData.birthDate ? new Date(patientData.birthDate) : null);
      form["idExpiry"].patchValue(patientData.idExpiry ? new Date(patientData.idExpiry) : null);
      form["Remarks"].patchValue(this.dilogData.waitingPatient?.remarks || "");
      form["addressPrimary"].patchValue(patientData.extendedAddress?.addressLine || "");
      form["pincodePrimary"].patchValue(patientData.extendedAddress?.postCode || "");
      form["realdob"].patchValue(this.dilogData.waitingPatient?.isReal || false);
      form["firstName"].patchValue(patientData?.firstName || "");
      form["middleName"].patchValue(patientData?.middleName || "");
      form["lastName"].patchValue(patientData?.lastName || "");
      form["mfirstName"].patchValue(patientData?.mfirstName || "");
      form["mmiddleName"].patchValue(patientData?.mmiddleName || "");
      form["mlastName"].patchValue(patientData?.mlastName || "");
    }else{
      this.patientType="registered";
      // this.radioClicked1(this.selectedPatient);
      const mrn = this.selectedPatient?.identifier?.[0]?.value;
      if (mrn) {
        this.setSearch({ MRN: mrn }, true);
      }
      this.appointmentForm.disable();
    this.appointmentForm.get('visitType')?.enable();
    this.appointmentForm.get('Remarks')?.enable();
    this.appointmentForm.get('priority')?.enable();
    this.appointmentForm.get('specialInstruction')?.enable();
    this.appointmentForm.get('needTranslator')?.enable();
      this.appointmentForm.get('translatorLanguage')?.enable();
      this.visitType.disable();
      this.teleConsultCtrl.disable();
      this.deptCtrl.disable();
    } 
  }
  convertTimestampsToDates(timestamps: number[]): string {
    return timestamps
      .map(timestamp => this.datepipe.transform(new Date(timestamp * 1000), 'dd/MM/yyyy'))
      .join(', ');
  }
   searchByPostCode(event) {
     this.isGetAddress = event.checked;
  }

  getAddressByPostCode(value) {
    if (!value) {
      return;
    }

    const stringValue = value.toString();
    if (stringValue.length >= 4 && this.isGetAddress) {
      const postCode = value;
      this.appBaseService.setResourceURL(OPD_API_URL.MASTER_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.GET_ADDRESS_BY_POSTCODE + postCode)
        .subscribe((res: any) => {
          if (res && res.payload) {
            this.isAddeassByPostCode = true;
            this.countryValue = res.payload.country ? res.payload.country.code : "";
            this.stateValue = res.payload.state ? res.payload.state.code : "";
            this.cityValue = res.payload.city ? res.payload.city.code : "";
            this.districtValue = res.payload.area ? res.payload.area.code : "";

            if (this.countryValue) {
              this.getStatePrimaryList(this.countryValue, true);
            }
          } else {
            this.snackBar.open("Postcode Not Found.", "Error", { duration: 1000 });
          }
        });
    }
  }

  primaryDistrictSelected(event) {
    if (event && event.postCode) {
      this.appointmentForm.patchValue({
        pincodePrimary: event.postCode,
      });
    }
  }
  emailOrMaskedValidator(): ValidatorFn {
    const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const maskedPattern = /^[a-zA-Z]\*+[a-zA-Z]$/;
  
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
  
      const isEmail = emailPattern.test(value);
      const isMasked = maskedPattern.test(value);
  
      return isEmail || isMasked ? null : { invalidEmailOrMask: true };
    };
  }
}

